(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/_components/alert.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/_components/alert.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"message\"\n    [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">\n    {{message.text}}</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<link rel=\"stylesheet\" href=\"https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css\"\n  integrity=\"sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T\" crossorigin=\"anonymous\" />\n\n\n<alert></alert>\n\n<router-outlet>\n</router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/access/access.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/access/access.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>access works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/dashboard.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/dashboard.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-sidenav-container class=\"sidenav-container\">\n  <mat-sidenav #drawer class=\"sidenav\" fixedInViewport=\"false\" [attr.role]=\"(isHandset$ | async) ? 'dialog' : 'navigation'\" [mode]=\"(isHandset$ | async) ? 'over' : 'side'\" [opened]=\"!(isHandset$ | async)\">\n\n    <mat-toolbar>\n      <img class=\"card ccProfilePicture\" src={{data}}>\n      <label class=\"ccUserName\">{{ userName }}</label>\n    </mat-toolbar>\n    <mat-nav-list>\n      <mat-list-item class=\"ccAllDeviceIcon ccNavBarContentSpacing\" [routerLinkActive]=\"['active']\" (click)=\"navigateTo('things')\">\n        <mat-icon class=\"ccTabIcon \" matListIcon>filter_none</mat-icon>\n        All Devices\n      </mat-list-item>\n      <div *ngIf=\"loading\" class=\"row justify-content-center\">\n        <img class=\"ccLoading\" src=\"assets/_images/loading.gif\" />\n      </div>\n      <div *ngIf=\"placeNameSet\">\n        <div *ngFor=\"let placeName of placeNameSet\">\n          <mat-list class=\"ccNestedItems\">\n            <mat-list-item (click)=\"getPlaceNameDevices(placeName)\">{{ placeName }}\n            </mat-list-item>\n          </mat-list>\n        </div>\n      </div>\n      <!-- <mat-list-item\n        [routerLinkActive]=\"['active']\"\n        (click)=\"navigateTo('access')\"\n      >\n        <mat-icon class=\"ccNavbarIcon\">vpn_key</mat-icon> Access\n      </mat-list-item>\n      <mat-list-item\n        [routerLinkActive]=\"['active']\"\n        (click)=\"navigateTo('settings')\"\n      >\n        <mat-icon class=\"ccNavbarIcon\">settings</mat-icon>\n        Settings\n      </mat-list-item> -->\n      <mat-list-item (click)=\"logout()\">Logout</mat-list-item>\n    </mat-nav-list>\n  </mat-sidenav>\n  <mat-sidenav-content>\n    <mat-toolbar style=\"height:100px;\">\n      <button type=\"button\" aria-label=\"Toggle sidenav\" mat-icon-button (click)=\"drawer.toggle()\" *ngIf=\"isHandset$ | async\">\n        <mat-icon aria-label=\"Side nav toggle icon\">menu</mat-icon>\n      </button>\n\n      <input type=\"text \" class=\"form-control ccSearchBar\" placeholder=\"Search...\" (input)=\"onSearchChange($event.target.value)\" />\n      <span class=\"ccSpace\"></span>\n      <button type=\"button\" class=\"btn  ccNotificationIcon  \">\n        <mat-icon class=\"ccNotificationIconSize\">notification_important</mat-icon>\n      </button>\n      <button id=\"button-basic\" type=\"button\" class=\"btn \">\n        <input class=\"ccAddIcon\" type=\"image\" src=\"assets/_images/add_toolbar.png\" />\n      </button>\n    </mat-toolbar>\n    <router-outlet></router-outlet>\n  </mat-sidenav-content>\n</mat-sidenav-container>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/settings/settings.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/settings/settings.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>settings works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/msater-control/msater-control.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/msater-control/msater-control.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\" ccSpacing text-center\">Alert</div>\n<div mat-dialog-content>\n    <div class=\" ccSpacing text-center\">\n        You are controlling all devices of the selected board\n    </div>\n\n    <div mat-dialog-content class=\"ccDialogBox\">\n        <div class=\"row justify-content-center ccPageMargin\">\n            <button class=\"ccOnDevice\" mat-dialog-close=\"ON\" (click)=\"masterControl('ON')\" cdkFocusInitial>ON\n                Devices</button>\n            <button class=\" ccOffDevices\" mat-dialog-close=\"OFF\" (click)=\"masterControl('OFF')\" cdkFocusInitial>OFF\n                Devices\n            </button>\n        </div>\n\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.html":
/*!**************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.html ***!
  \**************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div mat-dialog-content>\n    <p>\n        Enter the Number to be Added\n        <mat-form-field>\n            <input matInput [(ngModel)]=\"data.newNumber\" />\n        </mat-form-field>\n    </p>\n</div>\n\n<div class=\"row justify-content-center\" mat-dialog-actions>\n    <button mat-button (click)=\"onNoClick()\">Cancle</button>\n    <button mat-button [mat-dialog-close]=\"data.newNumber\" cdkFocusInitial>\n        Save\n    </button>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.html":
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.html ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n  <div class=\"ccThingSettingEditToolbar \">\n    <div class=\"row\">\n      <div class=\"col-6 border-right \">\n        <div class=\"row justify-content-center\">\n          <div class=\"col-4 \">\n            <button type=\"button\" class=\"btn col-1\">\n              <input class=\"ccBackIcon\" type=\"image\" src=\"assets/_images/iback-black.png\" [routerLink]=\"[\n                  '/dashboard/thingDetails/' + toDetailPage + '/power1'\n                ]\" />\n            </button>\n          </div>\n          <div class=\"col-8 ccColor ccToolbarTitle\">\n            <p>\n              Device Location\n            </p>\n          </div>\n        </div>\n        <form [formGroup]=\"deviceLocation\" class=\"row justify-content-center ccToolBarDropDown\">\n          <div class=\"form-group \">\n            <div class=\"btn-group \" dropdown>\n              <button dropdownToggle type=\"button\" class=\"btn ccDeviceDropDown \" aria-controls=\"dropdown-basic\">\n                {{ selectedDeviceLocationString }}\n                <input class=\"ccDropDown\" type=\"image\" src=\"assets/_images/drop-down.png\" />\n              </button>\n              <ul *dropdownMenu class=\"dropdown-menu \" role=\"menu\" aria-labelledby=\"button-basic\">\n                <div *ngFor=\"let deviceLocation of placeNameSet\">\n                  <li role=\"menuitem\" class=\"dropdown-item\" (click)=\"getDeviceLocation(deviceLocation)\">\n                    {{ deviceLocation }}\n                  </li>\n                </div>\n              </ul>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class=\"col-6  \">\n        <div class=\"row justify-content-center\">\n          <!-- <div class=\"col-5 text-right\">\n            <!-- <img\n              class=\"ccPinIcon \"\n              src=\"assets/_images/pin.png\"\n              \n            /> -->\n          <!-- </div> -->\n          -->\n          <div class=\"  ccToolbarTitleRoomName \">\n            <p>\n              Room Name\n            </p>\n          </div>\n        </div>\n        <div class=\"row justify-content-center\">\n          <div class=\"col\">\n            <form [formGroup]=\"roomName\" class=\"ccToolBarDropDownRoomName text-center \">\n              <div class=\"form-group \">\n                <div class=\"btn-group  \" dropdown>\n                  <button dropdownToggle type=\"button\" class=\"btn  \" aria-controls=\"dropdown-basic\">\n                    {{ selectedRoomNameString }}\n                    <input class=\"ccDropDown \" type=\"image\" src=\"assets/_images/drop-down.png\" />\n                  </button>\n                  <ul *dropdownMenu class=\"dropdown-menu ccDropDownLength dropdown-menu-right \" role=\"menu\"\n                    aria-labelledby=\"button-basic\">\n                    <div *ngFor=\"let roomName of roomNameArray\">\n                      <li role=\"menuitem\" class=\"dropdown-item\" data-toggle=\"modal\" (click)=\"getRoomName(roomName)\">\n                        {{ roomName }}\n                      </li>\n                    </div>\n                  </ul>\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"addNewUser\"></div>\n  <ng-container>\n    <div *ngIf=\"loading\" class=\"row justify-content-center\">\n      <img class=\"ccLoading\" src=\"assets/_images/loading.gif\" />\n    </div>\n    <div class=\" row\">\n      <ng-container *ngFor=\"let accessory of availableAccessory | keyvalue\">\n        <ng-container *ngIf=\"\n            accessory.value.accessoryIdentifier !== 'firmware' &&\n            accessory.value.accessoryIdentifier !== 'restart'\n          \">\n          <div class=\"card-deck ccCardSpacing \">\n            <div class=\"card text-center ccAccessoryEditCard\">\n              <div *ngFor=\"let status of accessory.value.statusList | keyvalue\">\n                <div *ngIf=\"status.value.statusId === 'power'\" class=\"card-header ccCardHeaderColor\">\n                  {{ status.value.displayname }}\n                </div>\n              </div>\n              <div class=\"card-body\">\n                <div class=\"row\">\n                  <div class=\"col-3 card text-center ccThingImageContainer d-flex\">\n                    <div class=\"card-body align-items-center d-flex justify-content-center\">\n                      <div *ngFor=\"\n                          let deviceTypeSelection of deviceTypeMap | keyvalue\n                        \">\n                        <div *ngIf=\"\n                            deviceTypeSelection.key ===\n                            accessory.value.accessoryIdentifier\n                          \">\n                          <div>\n                            <img class=\"ccThingImage\" src=\"assets/_images/{{\n                                deviceTypeSelection.value.displayName\n                                  | lowercase\n                              }}.png\" />\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\" col-  ccCardTitle\">\n                    Please select the device type\n                    <div>\n                      <form [formGroup]=\"deviceTypeName\">\n                        <div class=\" form-group \">\n                          <div class=\"btn-group\" dropdown>\n                            <button dropdownToggle type=\"button\" class=\"btn  ccdeviceTypeName \">\n                              <div *ngFor=\"\n                                  let deviceTypeSelection of deviceTypeMap\n                                    | keyvalue\n                                \">\n                                <div *ngIf=\"\n                                    deviceTypeSelection.key ===\n                                    accessory.value.accessoryIdentifier\n                                  \">\n                                  <div class=\"row justify-content-left\">\n                                    <div>\n                                      {{\n                                        deviceTypeSelection.value.displayName\n                                      }}\n                                    </div>\n                                    <mat-icon class=\"ccDropDownDeviceTyoe\">keyboard_arrow_down</mat-icon>\n                                  </div>\n                                </div>\n                              </div>\n                            </button>\n\n                            <ng-container *ngIf=\"accessory.canChangeType\">\n                              <ul *dropdownMenu class=\"dropdown-menu ccDropDownLength dropdown-menu-left\" role=\"menu\">\n                                <div *ngFor=\"let deviceType of deviceTypeNameArray\">\n                                  <li role=\"menuitem\" class=\"dropdown-item\" (click)=\"\n                                    getDeviceTypeName(\n                                      deviceType,\n                                      accessory.value.statusList[0].displayname,\n                                      accessory.value.statusList[0]\n                                        .accessoryIdentifier\n                                    )\n                                  \">\n                                    {{ deviceType }}\n                                  </li>\n                                </div>\n                              </ul>\n\n                            </ng-container>\n                          </div>\n                        </div>\n                      </form>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"card-footer ccCardFooter\">\n                <p>Please Enter the Switch Name</p>\n                <div>\n                  <form [formGroup]=\"deviceSwitchName\">\n                    <input class=\"ccdeviceTypeName\" value=\"{{ accessory.value.thingName }}\" formControlName=\"switchName\"\n                      (click)=\"inputChange(accessory.value.accessoryIdentifier)\" />\n\n                    <mat-icon *ngIf=\"\n                        inputSave &&\n                        accessory.value.accessoryIdentifier ===\n                          accessoryIdentifierinput\n                      \" (click)=\"\n                        deviceNmeAction(accessory.value.accessoryIdentifier)\n                      \" class=\"ccTabIcon \" matListIcon>check_circle_outline</mat-icon>\n                  </form>\n                </div>\n              </div>\n            </div>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n\n    <button id=\"button-basic\" type=\"button\" class=\"btn float-right\" (click)=\"saveEdittedData()\">\n      <input class=\"ccSaveIcon\" type=\"image\" src=\"assets/_images/save-icon.png\" />\n    </button>\n  </ng-container>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container-fluid\">\n  <div *ngIf=\"loading\" class=\"row justify-content-center\">\n    <img class=\"ccLoading\" src=\"assets/_images/loading.gif\" />\n  </div>\n  <div class=\"row ccDetailActionBar\">\n    <div class=\"col\">\n      <a><img src=\"assets/_images/icback.png\" [routerLink]=\"['/dashboard/things/']\" class=\"ccBackIcon\" /></a>\n    </div>\n    <div class=\"col align-items-end\">\n      <img src=\"assets/_images/icPower.png\" class=\"ccPowerIcon\" (click)=\"openDialog()\" />\n      <img *ngIf=\"!isUser\" src=\"assets/_images/icEdit.png\" class=\"ccEditIcon\" (click)=\"editThing(selectedMacId)\" />\n\n\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"selectedThing\">\n    <div *ngIf=\"selectedThing.thingType === 'laptop'\">\n      <ng-container *ngFor=\"let accessory of availableAccessory | keyvalue\">\n        <ng-container *ngIf=\"\n            accessory.value.accessoryIdentifier !== 'firmware' &&\n            accessory.value.accessoryIdentifier !== 'restart'\n          \">\n          <div>\n            <div class=\"row\">\n              <div *ngFor=\"let status of accessory.value.statusList | keyvalue\">\n                <div *ngIf=\"status.key === 'battery'\">\n                  <div class=\"card ccAccessoryCardBattery\">\n                    <div class=\"row card-body\">\n                      <div class=\" col-4 card justify-content-center ccInnerButtonCard\">\n                        <div class=\"card-body align-items-center d-flex justify-content-center\" *ngFor=\"\n                            let item of status.value.currentStatus[0] | keyvalue\n                          \">\n                          <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                              selectedThing.manufacturerDetails.manufacturer\n                                | replace\n                                | lowercase\n                            }}/{{\n                              accessory.value.accessoryType\n                                | replace\n                                | lowercase\n                            }}/{{ status.value.iconType | lowercase }}.png\" />\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"col-8 text-end ccThingNameBattery \">\n                      Battery\n                      {{ status.value.currentStatus[0].batteryStatus }}\n                    </div>\n                  </div>\n                </div>\n                <div *ngIf=\"status.key === 'power' || status.key === 'lock'\">\n                  <ng-container *ngFor=\"\n                      let control of accessory.value.thingControl | keyvalue\n                    \">\n                    <ng-container *ngIf=\"status.key === control.key\">\n                      <div class=\"card ccAccessoryCard  \" [ngStyle]=\"{\n                          opacity: selectedThing.isOnline ? '1' : '0.2'\n                        }\">\n                        <div class=\"card-body\">\n                          <ng-container *ngIf=\"\n                              status.value.hasStatusImage;\n                              else elseTemplate\n                            \">\n                            <div class=\"row\">\n                              <div class=\" col-4 card text-center ccInnerButtonCard\">\n                                <div class=\"card-body align-items-center d-flex justify-content-center\" *ngFor=\"\n                                    let item of status.value.currentStatus[0]\n                                      | keyvalue\n                                  \">\n                                  <button id=\"button-basic\" type=\"button\" class=\"btn\">\n                                    <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                        selectedThing.manufacturerDetails\n                                          .manufacturer\n                                          | replace\n                                          | lowercase\n                                      }}/{{\n                                        accessory.value.accessoryType\n                                          | replace\n                                          | lowercase\n                                      }}/{{\n                                        status.value.iconType | lowercase\n                                      }}/{{ item.key | lowercase }}.png\" (click)=\"actionCall(accessory.value)\" />\n                                  </button>\n                                </div>\n                              </div>\n\n                              <div class=\"col-8 text-end ccThingName \">\n                                {{ control.key }}\n                              </div>\n                            </div>\n                          </ng-container>\n                          <!-- Status without status image -->\n                          <ng-template #elseTemplate>\n                            <ng-container *ngFor=\"\n                                let item of status.value.states[0] | keyvalue\n                              \">\n                              <div>\n                                <img class=\"ccThingImage\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                    selectedThing.manufacturerDetails\n                                      .manufacturer\n                                      | replace\n                                      | lowercase\n                                  }}/{{\n                                    accessory.value.accessoryType\n                                      | replace\n                                      | lowercase\n                                  }}/{{ status.iconType | lowercase }}.png\" />\n                              </div>\n                              <div>\n                                {{ status.key }}\n                              </div>\n                            </ng-container>\n                          </ng-template>\n                        </div>\n                      </div>\n                    </ng-container>\n                  </ng-container>\n                </div>\n              </div>\n            </div>\n            <div>\n              <div *ngFor=\"let status of accessory.value.statusList | keyvalue\">\n                <div *ngIf=\"\n                    status.key === 'powerPointApp' || status.key === 'iTunesApp'\n                  \">\n                  <ng-container *ngFor=\"\n                      let control of accessory.value.thingControl | keyvalue\n                    \">\n                    <ng-container *ngIf=\"status.key === control.key\">\n                      <div class=\"card ccButtonArrayCardLaptop text-center\">\n                        <ng-container *ngIf=\"control.value.type === 'buttonArray'\">\n                          <div class=\"row justify-content-center\">\n                            <div *ngFor=\"\n                                let buttonControl of control.value.states[0] | keyvalue\n                              \">\n                              <div *ngFor=\"let buttonStatus of status.value.currentStatus[0]|keyvalue\">\n                                <div *ngIf=buttonStatus.key>\n                                  <div *ngIf=\"buttonStatus.key===buttonControl.key ;else elseButton\">\n                                    <div class=\" text-center\">\n                                      <div>\n                                        <button id=\"button-basic\" type=\"button\" class=\"btn\">\n                                          <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                            selectedThing.manufacturerDetails\n                                              .manufacturer\n                                              | replace\n                                              | lowercase\n                                          }}/{{\n                                            accessory.value.accessoryType\n                                              | replace\n                                              | lowercase\n                                          }}/{{\n                                            control.value.iconType\n                                              | replace\n                                              | lowercase\n                                          }}/{{\n                                            buttonStatus.value[0] | replace | lowercase\n                                          }}.png\" />\n                                        </button>\n                                      </div>\n                                    </div>\n                                  </div>\n                                  <ng-template #elseButton>\n                                    <div class=\" text-center\">\n                                      <div>\n                                        <button id=\"button-basic\" type=\"button\" class=\"btn\">\n                                          <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                        selectedThing.manufacturerDetails\n                                          .manufacturer\n                                          | replace\n                                          | lowercase\n                                      }}/{{\n                                        accessory.value.accessoryType\n                                          | replace\n                                          | lowercase\n                                      }}/{{\n                                        control.value.iconType\n                                          | replace\n                                          | lowercase\n                                      }}/{{\n                                        buttonControl.value[0] | replace | lowercase\n                                      }}.png\" />\n                                        </button>\n                                      </div>\n                                    </div>\n                                  </ng-template>\n                                </div>\n                              </div>\n\n                            </div>\n                          </div>\n                        </ng-container>\n                      </div>\n                    </ng-container>\n                  </ng-container>\n                </div>\n              </div>\n            </div>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div *ngIf=\"selectedThing.thingType != 'laptop'\">\n      <div class=\" row \">\n        <ng-container *ngFor=\"let accessory of availableAccessory | keyvalue\">\n          <ng-container *ngIf=\"\n              accessory.value.accessoryIdentifier !== 'firmware' &&\n              accessory.value.accessoryIdentifier !== 'restart'\n            \">\n            <ng-container *ngFor=\"let status of accessory.value.statusList\">\n              <ng-container *ngFor=\"let control of accessory.value.thingControl\">\n                <ng-container *ngIf=\"status.statusId === control.controlIdentifier\">\n                  <!-- <div\n                    class=\"card ccAccessoryCard\"\n                    [ngStyle]=\"{\n                      opacity: selectedThing.isOnline ? '1' : '0.2'\n                    }\"\n                  > -->\n                  <ng-container *ngIf=\"control.type === 'toggle'\">\n                    <div class=\"card  ccAccessoryCard\" [ngStyle]=\"{\n                        opacity: selectedThing.isOnline ? '1' : '0.2'\n                      }\">\n                      <div class=\"card-body\">\n                        <ng-container *ngIf=\"status.hasStatusImage; else elseTemplate\">\n                          <div class=\"row\">\n                            <div class=\" col-4 card text-center ccInnerButtonCard\">\n                              <div class=\"card-body align-items-center d-flex justify-content-center\" *ngFor=\"\n                                  let item of status.currentState[0] | keyvalue\n                                \">\n                                <button id=\"button-basic\" type=\"button\" class=\"btn\">\n                                  <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                      selectedThing.manufacturerDetails\n                                        .manufacturer\n                                        | replace\n                                        | lowercase\n                                    }}/{{\n                                      accessory.value.accessoryType\n                                        | replace\n                                        | lowercase\n                                    }}/{{ status.iconType | lowercase }}/{{\n                                      item.value | lowercase\n                                    }}.png\" (click)=\"actionCall(accessory.value)\" />\n                                </button>\n                              </div>\n                            </div>\n\n                            <div class=\"col-8  ccThingName \">\n                              {{ accessory.value.thingName }}\n                            </div>\n                          </div>\n                        </ng-container>\n                        <!-- Status without status image -->\n                        <ng-template #elseTemplate>\n                          <ng-container *ngFor=\"\n                              let item of status.currentState[0] | keyvalue\n                            \">\n                            <div>\n                              <img class=\"ccThingImage\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                  selectedThing.manufacturerDetails\n                                    .manufacturer\n                                    | replace\n                                    | lowercase\n                                }}/{{\n                                  accessory.value.accessoryType\n                                    | replace\n                                    | lowercase\n                                }}/{{ status.iconType | lowercase }}.png\" />\n                            </div>\n                            <div>\n                              {{ accessory.value.thingName }}\n                            </div>\n                          </ng-container>\n                        </ng-template>\n                      </div>\n                    </div>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"control.type === 'seekBar'\">\n                    <div class=\"card ccAccessoryCard\" [ngStyle]=\"{\n                        opacity: selectedThing.isOnline ? '1' : '0.2'\n                      }\">\n                      <div class=\"text-center\">\n                        <div class=\"ccFanThingName\">Seed Control</div>\n                        <div>\n                          <mat-slider class=\"ccSlider\" thumbLabel tickInterval=\"1\"\n                            min=\"{{ getMinValue(control.states) }}\" max=\"{{ getMaxValue(control.states) }}\" step=\"1\"\n                            value=\"{{ getCurrentValue(status.currentState) }}\"\n                            (input)=\"onInputChange($event,accessory.value)\">\n                          </mat-slider>\n                        </div>\n                        <div class=\"ccFanThingName\">\n                          {{ getCurrentValue(status.currentState) }}\n                        </div>\n                      </div>\n                    </div>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"control.type === 'curtain'\">\n                    <div class=\"card ccAccessoryCardCurtain\" [ngStyle]=\"{\n                        opacity: selectedThing.isOnline ? '1' : '0.2'\n                      }\">\n                      <div class=\"col \" *ngIf=\"availableControls\">\n                        <div *ngFor=\"let controls of availableControls | keyvalue\">\n                          <div class=\" row justify-content-end ccCurtainCard\" *ngIf=\"\n                              controls.value.controlIdentifier === 'curtain'\n                            \">\n                            <div *ngFor=\"\n                                let state of controls.value.states | keyvalue\n                              \">\n                              <div class=\"card ccCurtainButtons justify-content-start\">\n                                <input class=\"ccButtonArrayImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/cogcons_pvt_ltd/{{\n                                    accessory.value.accessoryType\n                                      | replace\n                                      | lowercase\n                                  }}/{{\n                                    controls.value.iconType | lowercase\n                                  }}/{{ getCurtainState(state.value) }}.png\" (click)=\"\n                                    curtainActionCall(\n                                      state.value,\n                                      controls.value\n                                    )\n                                  \" />\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\" row justify-content-start ccMargin  \">\n                        <ng-container *ngIf=\"status.hasStatusImage; else elseTemplate\">\n                          <div class=\"row\">\n                            <div class=\" col-5 card text-start ccInnerButtonCard\">\n                              <div class=\"card-body align-items-center d-flex justify-content-center\" *ngFor=\"\n                                  let item of status.currentState[0] | keyvalue\n                                \">\n                                <button id=\"button-basic\" type=\"button\" class=\"btn\">\n                                  <input class=\"ccThingImage\" type=\"image\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                      selectedThing.manufacturerDetails\n                                        .manufacturer\n                                        | replace\n                                        | lowercase\n                                    }}/{{\n                                      accessory.value.accessoryType\n                                        | replace\n                                        | lowercase\n                                    }}/{{ status.iconType | lowercase }}/{{\n                                      item.value | lowercase\n                                    }}.png\" (click)=\"actionCall(accessory.value)\" />\n                                </button>\n                              </div>\n                            </div>\n\n                            <div class=\"col-7 text-end ccThingName \">\n                              {{ accessory.value.thingName }}\n                            </div>\n                          </div>\n                        </ng-container>\n                        <!-- Status without status image -->\n                        <ng-template #elseTemplate>\n                          <ng-container *ngFor=\"\n                              let item of status.currentState[0] | keyvalue\n                            \">\n                            <div>\n                              <img class=\"ccThingImage\" src=\"https://cogcons-things.s3.ap-south-1.amazonaws.com/things/{{\n                                  selectedThing.manufacturerDetails\n                                    .manufacturer\n                                    | replace\n                                    | lowercase\n                                }}/{{\n                                  accessory.value.accessoryType\n                                    | replace\n                                    | lowercase\n                                }}/{{ status.iconType | lowercase }}.png\" />\n                            </div>\n                            <div>\n                              {{ accessory.value.thingName }}\n                            </div>\n                          </ng-container>\n                        </ng-template>\n                      </div>\n                    </div>\n                  </ng-container>\n                  <ng-container> </ng-container>\n                  <!-- </div> -->\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n\n    <div class=\"ccControlRow\">\n      <!-- <p class=\"ccMemberAccess\">Other Controls</p> -->\n\n      <ng-container *ngFor=\"let control of availableControls | keyvalue\">\n        <!-- <ng-container *ngIf=\"control.value.controlIdentifier === 'firmware'\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">{{ control.value.displayName }}</p>\n            </div>\n            <div class=\"col-md-3\">\n              <button class=\"btn btn-info ccControlButton\">Update</button>\n            </div>\n          </div>\n        </ng-container> -->\n\n        <ng-container *ngIf=\"control.value.controlIdentifier === 'restart'\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">{{ control.value.displayName }}</p>\n            </div>\n            <div class=\"col-md-3\">\n              <button class=\"btn btn-info ccControlButton\">Restart</button>\n            </div>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div class=\"ccMemberAccessRow\">\n\n      <div class=\"row\">\n        <div class=\"col-0.5\">\n          <img class=\"ccMemberAccessIcon\" src=\"assets/_images/user.png\" />\n        </div>\n        <div class=\"col\">\n          <p class=\"ccMemberAccess\">Member Access</p>\n        </div>\n      </div>\n      <div>\n        <div>\n          <div class=\"row card ccAdminsCard \">\n            <div class=\"row align-content-between ccMemberAccessMargin\">\n\n              <p class=\" ccAdminTitle\">Admins</p>\n              <button *ngIf=\"!isUser\" id=\"button-basic\" type=\"button\" class=\"btn\" (click)=\"openDialogforAdmin()\">\n                <input class=\"ccAddIcon\" type=\"image\" src=\"assets/_images/add_toolbar.png\" />\n              </button>\n            </div>\n\n\n            <ng-container *ngIf=\"selectedThing.admins\">\n              <div class=\"row-md-2 \">\n                <div class=\"col-md-12\">\n                  <div class=\"card-deck\">\n                    <div *ngFor=\"let admins of selectedThing.admins\">\n                      <div class=\"col- ccInnerCardMargin\">\n                        <img class=\"card ccProfilePicture\" [src]=\"getProfilePicture(admins)\">\n                        <p>{{ admins}}</p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </div>\n\n\n      <div *ngIf=\"selectedThing.userAccess.length >0 \">\n\n        <div *ngFor=\"let userGroup of selectedThing.userAccess\">\n\n          <div class=\"row card ccAdminsCard \">\n            <div class=\"row align-content-between ccMemberAccessMargin\">\n              <p class=\" ccAdminTitle\">{{userGroup.groupName}}</p>\n              <button *ngIf=\"!isUser\" id=\"button-basic\" type=\"button\" class=\"btn\"\n                (click)=\"openDialogforUser(userGroup.groupName)\">\n                <input class=\"ccAddIcon\" type=\"image\" src=\"assets/_images/add_toolbar.png\" />\n              </button>\n            </div>\n            <ng-container *ngIf=\"selectedThing.userAccess.length === 0\">\n              <div class=\"ccSave ccAvailableText ccSaveIconIcon ccRefreshIcon\">\n                <div (click)=\"saveModel() \">Save</div>\n              </div>\n            </ng-container>\n            <ng-container *ngIf=\"selectedThing.userAccess.length > 0\">\n              <div class=\"row-md-2\">\n                <div class=\"col-md-12\">\n                  <div class=\"card-deck\">\n                    <div *ngFor=\"let phoneNumber of userGroup.userList\">\n                      <div class=\"col- ccInnerCardMargin\">\n\n                        <img class=\"card ccProfilePicture\" src=\"{{getProfilePicture(phoneNumber)}}\">\n                        <p>{{ phoneNumber }}</p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\" ccThingInfoRow\">\n      <div class=\"row\">\n        <div class=\"col-0.5\">\n          <img class=\"ccMemberAccessIcon\" src=\"assets/_images/detail.png\" />\n        </div>\n        <div class=\"col\">\n          <h2 class=\"ccMemberAccess\"> Switch Board Details</h2>\n        </div>\n      </div>\n      <div class=\"ccBoardDetailsMargin\">\n        <ng-container *ngIf=\"selectedThing.manufacturerDetails.modelName\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">Model Name</p>\n            </div>\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">\n                {{ selectedThing.manufacturerDetails.modelName }}\n              </p>\n            </div>\n          </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"selectedThing.buildNumber\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">Build Number</p>\n            </div>\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">\n                {{ selectedThing.buildNumber }}\n              </p>\n            </div>\n          </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"selectedThing.manufacturerDetails.serialNumber\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">Serial Number</p>\n            </div>\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">{{ serialNumber }}</p>\n            </div>\n          </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"selectedThing.manufacturerDetails.manufacturer\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">Manufacture</p>\n            </div>\n            <div class=\"col-md-3\">\n              <p class=\"ccControlName\">\n                {{ selectedThing.manufacturerDetails.manufacturer }}\n              </p>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </ng-container>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/things.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/things.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-cloak>\n  <ng-container *ngIf=\"globalThingAndThingUIObject\">\n    <div *ngIf=\"loading\" class=\"row justify-content-center\">\n      <img class=\"ccLoading\" src=\"assets/_images/loading.gif\" />\n    </div>\n    <ng-container *ngFor=\"let eachThing of globalThingAndThingUIObject | keyvalue\">\n\n      <div class=\"card-body justify-content-center\">\n\n        <div class=\"row\">\n\n          <div *ngFor=\"let name of eachThing.key?.split('*')\">\n            <div *ngIf=\"name.includes('icon')\">\n\n              <img src=\"assets/_images/locationIcons/{{name.replace('icon','') | lowercase}}.png\" class=\"ccPinIcon \" />\n            </div>\n\n          </div>\n          <div class=\" col ccMacIdText\">\n            {{ eachThing.key.split('*')[0] }}\n          </div>\n\n          <img src=\"assets/_images/icPower.png\" class=\"ccPowerIcon \" (click)=\"openDialog(eachThing)\" />\n        </div>\n        <div class=\"row ccThings\">\n\n          <div *ngFor=\"let accessory of eachThing.value | keyvalue\">\n            <div class=\"card ccInnerCard d-flex\" (click)=\"thingControl(accessory.key, accessory.value.macId)\" [ngStyle]=\"{\n                opacity: accessory.value.isOnline ? '1' : '0.3'\n              }\">\n              <div class=\"card-body  d-flex justify-content-center \">\n                <div class=\"card text-center ccThingImageContainer d-flex\">\n                  <div class=\"card-body align-items-center d-flex justify-content-center \">\n                    <button id=\"button-basic\" type=\"button\" class=\"btn\" (click)=\"$event.stopPropagation()\">\n                      <input class=\"ccThingImage\" type=\"image\" src=\"{{ accessory.value.accessoryImageUrl }}\"\n                        (click)=\"actionCall(accessory.value)\" />\n                    </button>\n                  </div>\n                </div>\n              </div>\n\n              <h6 class=\"ccThingName text-center\">\n                {{ accessory.value.accessoryDisplayName }}\n              </h6>\n            </div>\n          </div>\n\n        </div>\n      </div>\n\n    </ng-container>\n  </ng-container>\n</div>\n\n<!-- <div class=\"modal ccModal\" tabindex=\"-1\" role=\"dialog\" [ngStyle]=\"{'display':displayModel}\">\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\" *ngIf=\"selectedThing\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\"> {{selectedThing.accessoryDisplayName}}</h5>\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"closeModel()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"row justify-content-center align-items-center ccStatusControl\">\n                    <div class=\"col align-items-center\">\n                        <button *ngIf='selectedThing.currentStatus==\"ON\"' (click)=\"publishStatus()\" type=\"button\"\n                            class=\"btn btn-danger ccControlStatus\">OFF</button>\n                        <button *ngIf=\"selectedThing.currentStatus=='OFF'\" (click)=\"publishStatus()\" type=\"button\"\n                            class=\"btn btn-success ccControlStatus\">ON</button>\n                        <p class=\"ccStatusDetailText\"\n                            *ngIf='thingsValue.value.accessoryType === \"current\" || thingsValue.value.accessoryType === \"voltage\" || thingsValue.value.accessoryType === \"consumption\"'>\n                            Reading: {{thingsValue.value.functions}}</p>\n                    </div>\n                    <div class=\"col align-items-center\">\n                        <img *ngIf=\"isSendingStatus\" class=\"ccStatusSendGif\" src=\"/assets/Spinner-1s-200px.svg\" />\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"loading\">\n    <img class=\"ccLoadingGif\" src=\"/assets/Spinner-1s-200px.svg\" />\n</div> -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"error\" class=\"alert alert-danger\">{{ error }}</div>\n<div *ngIf=\"success\" class=\"alert alert-success\">{{ success }}</div>\n<div class=\"jumbotron\" align=\"center\">\n  <form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\">\n    <img class=\"mb-4\" src=\"assets/_images/For_Designers.png\" alt=\"\" width=\"250\" height=\"150\" />\n    <h1 class=\"h3 mb-3 font-weight-normal\">\n      Please provide your credentials\n    </h1>\n    <div class=\"form-group\">\n      <input style=\"width: 300px;\" type=\"text\" formControlName=\"username\" ng2TelInput\n        [ng2TelInputOptions]=\"{ initialCountry: 'in' }\" (ng2TelOutput)=\"getNumber($event)\"\n        (countryChange)=\"onCountryChange($event)\" class=\"form-control\" [ngClass]=\"{\n          'is-invalid': submitted && formValidation.username.errors\n        }\" placeholder=\"Phone Number\" />\n      <div *ngIf=\"submitted && formValidation.username.errors\" class=\"invalid-feedback\">\n        <div *ngIf=\"formValidation.username.errors.required\">\n          Phone Number is required\n        </div>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <input style=\"width: 300px;\" type=\"password\" formControlName=\"password\" class=\"form-control\" [ngClass]=\"{\n          'is-invalid': submitted && formValidation.password.errors\n        }\" placeholder=\"Password\" />\n      <div *ngIf=\"submitted && formValidation.password.errors\" class=\"invalid-feedback\">\n        <div *ngIf=\"formValidation.password.errors.required\">\n          Password is required\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <button [disabled]=\"loading\" class=\"btn btn-lg btn-primary btn-block\" type=\"submit\" style=\"width: 300px;\">\n        Sign in\n      </button>\n    </div>\n    <div class=\"text-center\">\n      <div *ngIf=\"loading\">\n        <img class=\"ccLoading\" src=\"assets/_images/loading.gif\" />\n      </div>\n    </div>\n    <p class=\"mt-5 mb-3 text-muted\">&copy; COGCONS 2019</p>\n  </form>\n</div>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/_components/alert.component.ts":
/*!************************************************!*\
  !*** ./src/app/_components/alert.component.ts ***!
  \************************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return AlertComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");



let AlertComponent = class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
    }
    ngOnInit() {
        this.subscription = this.alertService.getAlert().subscribe(message => {
            this.message = message;
        });
    }
    ngOnDestroy() {
        if (this.subscription != null) {
            this.subscription.unsubscribe();
        }
    }
};
AlertComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_2__["AlertService"] }
];
AlertComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'alert',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./alert.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/_components/alert.component.html")).default
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services__WEBPACK_IMPORTED_MODULE_2__["AlertService"]])
], AlertComponent);



/***/ }),

/***/ "./src/app/_components/index.ts":
/*!**************************************!*\
  !*** ./src/app/_components/index.ts ***!
  \**************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.component */ "./src/app/_components/alert.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return _alert_component__WEBPACK_IMPORTED_MODULE_1__["AlertComponent"]; });





/***/ }),

/***/ "./src/app/_helpers/auth.guard.ts":
/*!****************************************!*\
  !*** ./src/app/_helpers/auth.guard.ts ***!
  \****************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");




let AuthGuard = class AuthGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            console.log("Valid user login found");
            return true;
        }
        console.log("Valid user not found");
        this.router.navigate(["/"], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: "root" }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        _services__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"]])
], AuthGuard);



/***/ }),

/***/ "./src/app/_helpers/error.interceptor.ts":
/*!***********************************************!*\
  !*** ./src/app/_helpers/error.interceptor.ts ***!
  \***********************************************/
/*! exports provided: ErrorInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorInterceptor", function() { return ErrorInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_authentication_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_services/authentication.service */ "./src/app/_services/authentication.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let ErrorInterceptor = class ErrorInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(err => {
            if (err.status === 401) {
                this.authenticationService.logout;
                location.reload(true);
            }
            const error = err.error.message || err.statusText;
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
        }));
    }
};
ErrorInterceptor.ctorParameters = () => [
    { type: _services_authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"] }
];
ErrorInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"]])
], ErrorInterceptor);



/***/ }),

/***/ "./src/app/_helpers/index.ts":
/*!***********************************!*\
  !*** ./src/app/_helpers/index.ts ***!
  \***********************************/
/*! exports provided: AuthGuard, JwtInterceptor, ErrorInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _auth_guard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./auth.guard */ "./src/app/_helpers/auth.guard.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return _auth_guard__WEBPACK_IMPORTED_MODULE_1__["AuthGuard"]; });

/* harmony import */ var _jwt_interceptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jwt.interceptor */ "./src/app/_helpers/jwt.interceptor.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return _jwt_interceptor__WEBPACK_IMPORTED_MODULE_2__["JwtInterceptor"]; });

/* harmony import */ var _error_interceptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./error.interceptor */ "./src/app/_helpers/error.interceptor.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorInterceptor", function() { return _error_interceptor__WEBPACK_IMPORTED_MODULE_3__["ErrorInterceptor"]; });







/***/ }),

/***/ "./src/app/_helpers/jwt.interceptor.ts":
/*!*********************************************!*\
  !*** ./src/app/_helpers/jwt.interceptor.ts ***!
  \*********************************************/
/*! exports provided: JwtInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return JwtInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_add_operator_do__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/add/operator/do */ "./node_modules/rxjs-compat/_esm2015/add/operator/do.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");





let JwtInterceptor = class JwtInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    token: currentUser.token
                }
            });
        }
        return next.handle(request).do((event) => {
            if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpResponse"]) {
                // do stuff with response if you want
            }
        }, (err) => {
            if (err instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpErrorResponse"]) {
                if (err.status === 403) {
                    this.authenticationService.logout();
                }
            }
        });
    }
};
JwtInterceptor.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_4__["AuthenticationService"] }
];
JwtInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services__WEBPACK_IMPORTED_MODULE_4__["AuthenticationService"]])
], JwtInterceptor);



/***/ }),

/***/ "./src/app/_helpers/replace.pipe.ts":
/*!******************************************!*\
  !*** ./src/app/_helpers/replace.pipe.ts ***!
  \******************************************/
/*! exports provided: ReplacePipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReplacePipe", function() { return ReplacePipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ReplacePipe = class ReplacePipe {
    transform(value) {
        return value.replace(/ /g, '_');
    }
};
ReplacePipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'replace'
    })
], ReplacePipe);



/***/ }),

/***/ "./src/app/_models/thing.ts":
/*!**********************************!*\
  !*** ./src/app/_models/thing.ts ***!
  \**********************************/
/*! exports provided: Thing */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Thing", function() { return Thing; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Thing {
    constructor(id, macId, serverId, action, thingType, groupBy, timeStamp, buildNumber, thingsLocation, roomName, accessories, info, admins, userAccess, isOnline, manufacturerDetails, isRegistred, isNewlyAdded, canChangeThingType, isLinkableThing, model, version, initialModel, initialVersion) {
        this.macId = macId;
        this.serverId = serverId;
        this.action = action;
        this.thingType = thingType;
        this.groupBy = groupBy;
        this.timeStamp = timeStamp;
        this.buildNumber = buildNumber;
        this.thingsLocation = thingsLocation;
        this.roomName = roomName;
        this.accessories = accessories;
        this.info = info;
        this.admins = admins;
        this.userAccess = userAccess;
        this.isOnline = isOnline;
        this.manufacturerDetails = manufacturerDetails;
        this.isRegistred = isRegistred;
        this.isNewlyAdded = isNewlyAdded;
        this.canChangeThingType = canChangeThingType;
        this.isLinkableThing = isLinkableThing;
        this.model = model;
        this.version = version;
        this.initialModel = initialModel;
        this.initialVersion = initialVersion;
    }
}


/***/ }),

/***/ "./src/app/_models/thingAccessories.ts":
/*!*********************************************!*\
  !*** ./src/app/_models/thingAccessories.ts ***!
  \*********************************************/
/*! exports provided: ThingAccessories */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingAccessories", function() { return ThingAccessories; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingAccessories {
    constructor(macID, ipAddress, accessoryIdentifier, thingName, roomName, statusList, thingControl, accessoryType, isLinkingAvailable, canChangeType, linkingMacId, removeLinkingMacId, isLinkableThing) {
        this.macID = macID;
        this.ipAddress = ipAddress;
        this.accessoryIdentifier = accessoryIdentifier;
        this.thingName = thingName;
        this.roomName = roomName;
        this.statusList = statusList;
        this.thingControl = thingControl;
        this.accessoryType = accessoryType;
        this.isLinkingAvailable = isLinkingAvailable;
        this.canChangeType = canChangeType;
        this.linkingMacId = linkingMacId;
        this.removeLinkingMacId = removeLinkingMacId;
        this.isLinkableThing = isLinkableThing;
    }
}


/***/ }),

/***/ "./src/app/_models/thingControl.ts":
/*!*****************************************!*\
  !*** ./src/app/_models/thingControl.ts ***!
  \*****************************************/
/*! exports provided: ThingControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingControl", function() { return ThingControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingControl {
    constructor(macId, controlIdentifier, type, topic, states, accessoryIdentifier, displayName, iconType, hasControlImage, isConfirmationRequire, linkIconType, linkDisplayName) {
        this.macId = macId;
        this.controlIdentifier = controlIdentifier;
        this.type = type;
        this.topic = topic;
        this.states = states;
        this.accessoryIdentifier = accessoryIdentifier;
        this.displayName = displayName;
        this.iconType = iconType;
        this.hasControlImage = hasControlImage;
        this.isConfirmationRequire = isConfirmationRequire;
        this.linkIconType = linkIconType;
        this.linkDisplayName = linkDisplayName;
    }
}


/***/ }),

/***/ "./src/app/_models/thingStatus.ts":
/*!****************************************!*\
  !*** ./src/app/_models/thingStatus.ts ***!
  \****************************************/
/*! exports provided: ThingStatus */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingStatus", function() { return ThingStatus; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingStatus {
    constructor(statusId, displayname, currentState, topic, accessoryIdentifier, thingMacId, hasStatusImage, iconType, linkIconType, linkDisplayName) {
        this.statusId = statusId;
        this.displayname = displayname;
        this.currentState = currentState;
        this.topic = topic;
        this.accessoryIdentifier = accessoryIdentifier;
        this.thingMacId = thingMacId;
        this.hasStatusImage = hasStatusImage;
        this.iconType = iconType;
        this.linkIconType = linkIconType;
        this.linkDisplayName = linkDisplayName;
    }
}


/***/ }),

/***/ "./src/app/_models/thingUiObject.ts":
/*!******************************************!*\
  !*** ./src/app/_models/thingUiObject.ts ***!
  \******************************************/
/*! exports provided: ThingUiObject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingUiObject", function() { return ThingUiObject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingUiObject {
    constructor(accessoryId, macId, buildNumber, accessoryImageUrl, accessoryDisplayName, accessoryLocationType, isNewelyRegistred, isOnline, currentStatus, statusTopic, controlTopic, eachthingName) {
        this.accessoryId = accessoryId;
        this.buildNumber = buildNumber;
        this.macId = macId;
        this.accessoryImageUrl = accessoryImageUrl;
        this.accessoryDisplayName = accessoryDisplayName;
        this.accessoryLocationType = accessoryLocationType;
        this.isNewelyRegistred = isNewelyRegistred;
        this.isOnline = isOnline;
        this.currentStatus = currentStatus;
        this.statusTopic = statusTopic;
        this.controlTopic = controlTopic;
        this.eachthingName = eachthingName;
    }
}


/***/ }),

/***/ "./src/app/_models/thingUserAccess.ts":
/*!********************************************!*\
  !*** ./src/app/_models/thingUserAccess.ts ***!
  \********************************************/
/*! exports provided: ThingUserAccess */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingUserAccess", function() { return ThingUserAccess; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingUserAccess {
    constructor(gropuName, userList, statusAccess, controlAccess) {
        this.groupName = gropuName;
        this.userList = userList;
        this.statusAccess = statusAccess;
        this.controlAccess = controlAccess;
    }
}


/***/ }),

/***/ "./src/app/_models/thingsLocation.ts":
/*!*******************************************!*\
  !*** ./src/app/_models/thingsLocation.ts ***!
  \*******************************************/
/*! exports provided: ThingsLocation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingsLocation", function() { return ThingsLocation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingsLocation {
    constructor(placeId, placeType, placeName, latitude, longitude, canEditLocation) {
        this.placeId = placeId;
        this.placeType = placeType;
        this.placeName = placeName;
        this.latitude = latitude;
        this.longitude = longitude;
        this.canEditLocation = canEditLocation;
    }
}


/***/ }),

/***/ "./src/app/_models/thingsManufactureDetails.ts":
/*!*****************************************************!*\
  !*** ./src/app/_models/thingsManufactureDetails.ts ***!
  \*****************************************************/
/*! exports provided: ThingsManufactureDetails */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingsManufactureDetails", function() { return ThingsManufactureDetails; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ThingsManufactureDetails {
    constructor(modelNumber, modelName, serialNumber, manufacturer, manufacturerUrl) {
        this.modelNumber = modelNumber;
        this.modelName = modelName;
        this.serialNumber = serialNumber;
        this.manufacturer = manufacturer;
        this.manufacturerUrl = manufacturerUrl;
    }
}


/***/ }),

/***/ "./src/app/_services/alert.service.ts":
/*!********************************************!*\
  !*** ./src/app/_services/alert.service.ts ***!
  \********************************************/
/*! exports provided: AlertService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return AlertService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let AlertService = class AlertService {
    constructor(router) {
        this.router = router;
        this.subject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.keepAfterRouteChange = false;
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationStart"]) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                }
                else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }
    getAlert() {
        return this.subject.asObservable();
    }
    success(message, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: "success", text: message });
    }
    error(message, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: "error", text: message });
    }
    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next();
    }
};
AlertService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AlertService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: "root" }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], AlertService);



/***/ }),

/***/ "./src/app/_services/authentication.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/_services/authentication.service.ts ***!
  \*****************************************************/
/*! exports provided: AuthenticationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return AuthenticationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");






let AuthenticationService = class AuthenticationService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.currentUserSubject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](JSON.parse(localStorage.getItem("currentUser")));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        // this.currentUserSubject = new BehaviorSubject<any>(
        //   JSON.parse(localStorage.getItem("currentUser"))
        // );
        // this.currentUser = this.currentUserSubject.asObservable();
        return this.currentUserSubject.value;
    }
    login(username, password, provider, AppVersion) {
        localStorage.clear();
        var loginBody = {
            phoneNumber: username,
            password: password,
            provider: "Angular",
            AppVersion: 10
        };
        console.log("Login details", loginBody);
        return this.http
            .post(`https://dev.cogcons.com/api/users/login`, loginBody)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(user => {
            user.phoneNumber = loginBody.phoneNumber;
            localStorage.setItem("currentUser", JSON.stringify(user));
            this.currentUserSubject.next(user);
            return user;
        }));
    }
    logout() {
        localStorage.removeItem("currentUser");
        this.currentUserSubject.next(null);
        this.router.navigate(["/"]);
    }
};
AuthenticationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] }
];
AuthenticationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: "root" }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"],
        _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"]])
], AuthenticationService);



/***/ }),

/***/ "./src/app/_services/dataStore.service.ts":
/*!************************************************!*\
  !*** ./src/app/_services/dataStore.service.ts ***!
  \************************************************/
/*! exports provided: dbrouting, DataStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dbrouting", function() { return dbrouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataStore", function() { return DataStore; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _models_thing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_models/thing */ "./src/app/_models/thing.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _models_thingUserAccess__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_models/thingUserAccess */ "./src/app/_models/thingUserAccess.ts");
/* harmony import */ var _models_thingsLocation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_models/thingsLocation */ "./src/app/_models/thingsLocation.ts");
/* harmony import */ var _models_thingsManufactureDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_models/thingsManufactureDetails */ "./src/app/_models/thingsManufactureDetails.ts");
/* harmony import */ var _models_thingAccessories__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../_models/thingAccessories */ "./src/app/_models/thingAccessories.ts");
/* harmony import */ var _models_thingStatus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../_models/thingStatus */ "./src/app/_models/thingStatus.ts");
/* harmony import */ var _models_thingControl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../_models/thingControl */ "./src/app/_models/thingControl.ts");
/* harmony import */ var _authentication_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./authentication.service */ "./src/app/_services/authentication.service.ts");
/* harmony import */ var _mission_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mission.service */ "./src/app/_services/mission.service.ts");
/* harmony import */ var _models_thingUiObject__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../_models/thingUiObject */ "./src/app/_models/thingUiObject.ts");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");













const dbConfig = {
    name: "thingDatabase",
    version: 1,
    objectStoresMeta: [
        {
            store: "Things",
            storeConfig: { keyPath: "macId", autoIncrement: false },
            storeSchema: [
                { name: "Thing", keypath: "thing", options: { unique: true } }
            ]
        },
        {
            store: 'thingUiObject',
            storeConfig: { keyPath: 'uiMacId', autoIncrement: false },
            storeSchema: [
                { name: 'Thing', keypath: 'thing', options: { unique: true } },
            ]
        },
        {
            store: 'locationList',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'name', keypath: 'name', options: { unique: true } },
            ]
        },
    ]
};
const dbrouting = ngx_indexed_db__WEBPACK_IMPORTED_MODULE_12__["NgxIndexedDBModule"].forRoot(dbConfig);
let DataStore = class DataStore {
    constructor(authService, missionService, dbService) {
        this.authService = authService;
        this.missionService = missionService;
        this.dbService = dbService;
        this.thingUIObject = new Map();
    }
    parseThingData(syncdata) {
        syncdata.forEach(thingsSyncData => {
            if (thingsSyncData.thing.status) {
                if (thingsSyncData.type === "thing") {
                    this.currentUser = this.authService.currentUserValue;
                    //Parsing Admin Json
                    if (thingsSyncData.admin) {
                        var admin = new Array();
                        admin = thingsSyncData.admin;
                    }
                    //Parsing UserAccess Json
                    var thingUserAccess = new Array();
                    if (thingsSyncData.thing["userAccess"]) {
                        thingsSyncData.thing["userAccess"].forEach(userAccessId => {
                            var userGroupName = userAccessId.name;
                            var userList = userAccessId.userList;
                            var enabledStatuses = userAccessId.status;
                            var enabledControls = userAccessId.controls;
                            let userAccess = new _models_thingUserAccess__WEBPACK_IMPORTED_MODULE_3__["ThingUserAccess"](userGroupName, userList, enabledStatuses, enabledControls);
                            thingUserAccess.push(userAccess);
                            // console.log(thingUserAccess)
                        });
                    }
                    //Parsing Thing Location
                    let thingLocation = new _models_thingsLocation__WEBPACK_IMPORTED_MODULE_4__["ThingsLocation"](thingsSyncData.thing.location.placeId, thingsSyncData.thing.location.placeType, thingsSyncData.thing.location.placeName, thingsSyncData.thing.location.latitude, thingsSyncData.thing.location.longitude, thingsSyncData.thing.location.canEditLocation);
                    //Parsing Thing Manufacture Details
                    let thingManufactureDetails = new _models_thingsManufactureDetails__WEBPACK_IMPORTED_MODULE_5__["ThingsManufactureDetails"](thingsSyncData.thing.manufacturerDetails.modelNumber, thingsSyncData.thing.manufacturerDetails.modelName, thingsSyncData.thing.manufacturerDetails.serialNumber, thingsSyncData.thing.manufacturerDetails.manufacturer, thingsSyncData.thing.manufacturerDetails.manufacturerURL);
                    //Parsing Thing Accessory
                    var thingAccessories = new Array();
                    var thingAccessoriesy;
                    if (thingsSyncData.thing.thingType === "laptop") {
                        if (thingsSyncData.thing.accessories.laptop) {
                            thingAccessoriesy = thingsSyncData.thing.accessories.laptop;
                            let thingAccessory = new _models_thingAccessories__WEBPACK_IMPORTED_MODULE_6__["ThingAccessories"](thingsSyncData.macId, "", "laptop", thingsSyncData.thing.accessoriesDetails["laptop"].name, thingsSyncData.thing.roomName, thingsSyncData.thing.accessories.laptop.status, thingsSyncData.thing.accessories.laptop.controls, "laptop", thingAccessoriesy.isLinkingAvailable, thingAccessoriesy.canChangeThingType, "", "", thingsSyncData.thing.isLinkableThing);
                            thingAccessories.push(thingAccessory);
                        }
                    }
                    else {
                        var thingAccessories = new Array();
                        if (thingsSyncData.thing.accessories) {
                            Object.keys(thingsSyncData.thing.accessories).forEach(accessoryId => {
                                var accessoryJson = thingsSyncData.thing.accessories[accessoryId];
                                if (thingsSyncData.thing.status) {
                                    var accessoryStatusJson = thingsSyncData.thing.status;
                                    var accessoryControlJson = accessoryJson.controls;
                                    var thingStatus = new Array();
                                    var thingControls = new Array();
                                    if (this.currentUser && admin.includes(this.currentUser.phoneNumber)) {
                                        //Parsing Status Json for Admins
                                        Object.keys(accessoryStatusJson).forEach(statusID => {
                                            var id = "";
                                            if (statusID.split("/").length > 1) {
                                                id = statusID.split("/")[1];
                                            }
                                            else {
                                                id = statusID;
                                            }
                                            var currentStateArray = new Array();
                                            for (var currentStateKey in accessoryStatusJson[statusID]) {
                                                if (thingsSyncData.thing.buildNumber >= 6) {
                                                    currentStateArray.push(new Map().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey]));
                                                }
                                                else if (accessoryStatusJson[statusID][currentStateKey][id]) {
                                                    currentStateArray.push(new Map().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey][id][0]));
                                                }
                                                else {
                                                    // console.log("Accessory JSON CHECK < 6", id, thingsSyncData.macId, accessoryStatusJson[statusID], thingsSyncData.thing.buildNumber);
                                                    // for (var stateId in accessoryStatusJson[statusID]) {
                                                    //   console.log("StatusId", thingsSyncData.macId, accessoryStatusJson[statusID][stateId])
                                                    // }
                                                }
                                                if (statusID.includes(accessoryId)) {
                                                    if (accessoryJson.status[id]) {
                                                        let status = new _models_thingStatus__WEBPACK_IMPORTED_MODULE_7__["ThingStatus"](id, accessoryJson.status[id].linkDisplayName, currentStateArray, accessoryJson.status[id].topicName, accessoryId, thingsSyncData.macId, accessoryJson.status[id].hasStatusImage, accessoryJson.status[id].iconType, accessoryJson.status[id].linkIconType, accessoryJson.status[id].linkDisplayName);
                                                        thingStatus.push(status);
                                                    }
                                                }
                                            }
                                        });
                                        //Parsing Control Json admins
                                        Object.keys(accessoryControlJson).forEach(controlID => {
                                            var availableControl = new Array();
                                            accessoryControlJson[controlID].states.forEach(availableStates => {
                                                for (var statesKey in availableStates) {
                                                    availableControl.push(new Map().set(statesKey, availableStates[statesKey]));
                                                }
                                            });
                                            let control = new _models_thingControl__WEBPACK_IMPORTED_MODULE_8__["ThingControl"](thingsSyncData.macId, controlID, accessoryControlJson[controlID].type, accessoryControlJson[controlID].topicName, availableControl, accessoryId, accessoryControlJson[controlID].linkDisplayName, accessoryControlJson[controlID].iconType, accessoryControlJson[controlID].hasControlImage, accessoryControlJson[controlID].isConfirmationRequired, accessoryControlJson[controlID].linkIconType, accessoryControlJson[controlID].linkDisplayName);
                                            thingControls.push(control);
                                        });
                                    }
                                    else {
                                        thingUserAccess.forEach(userAccess => {
                                            if (userAccess.userList.includes(this.currentUser.phoneNumber)) {
                                                //Parsing Status Json for Admins
                                                if (userAccess.controlAccess.length > 0) {
                                                    Object.keys(accessoryStatusJson).forEach(statusID => {
                                                        var id = "";
                                                        if (statusID.split("/").length > 1) {
                                                            id = statusID.split("/")[1];
                                                        }
                                                        else {
                                                            id = statusID;
                                                        }
                                                        var currentStateArray = new Array();
                                                        for (var currentStateKey in accessoryStatusJson[statusID]) {
                                                            if (thingsSyncData.thing.buildNumber >= 6) {
                                                                currentStateArray.push(new Map().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey]));
                                                            }
                                                            else if (accessoryStatusJson[statusID][currentStateKey][id]) {
                                                                currentStateArray.push(new Map().set(currentStateKey, accessoryStatusJson[statusID][currentStateKey][id][0]));
                                                            }
                                                            else {
                                                                // console.log("Accessory JSON CHECK < 6", id, thingsSyncData.macId, accessoryStatusJson[statusID], thingsSyncData.thing.buildNumber);
                                                                // for (var stateId in accessoryStatusJson[statusID]) {
                                                                //   console.log("StatusId", thingsSyncData.macId, accessoryStatusJson[statusID][stateId])
                                                                // }
                                                            }
                                                            if (statusID.includes(accessoryId)) {
                                                                if (accessoryJson.status[id]) {
                                                                    let status = new _models_thingStatus__WEBPACK_IMPORTED_MODULE_7__["ThingStatus"](id, accessoryJson.status[id].linkDisplayName, currentStateArray, accessoryJson.status[id].topicName, accessoryId, thingsSyncData.macId, accessoryJson.status[id].hasStatusImage, accessoryJson.status[id].iconType, accessoryJson.status[id].linkIconType, accessoryJson.status[id].linkDisplayName);
                                                                    thingStatus.push(status);
                                                                }
                                                            }
                                                        }
                                                    });
                                                }
                                                //Parsing Control Json admins
                                                Object.keys(accessoryControlJson).forEach(controlID => {
                                                    var accessFor = accessoryId + "/" + accessoryControlJson[controlID]["topicName"];
                                                    if (userAccess.controlAccess.includes(accessFor)) {
                                                        // console.log("Control ID", thingsSyncData.macId, controlID);
                                                        var availableControl = new Array();
                                                        accessoryControlJson[controlID].states.forEach(availableStates => {
                                                            for (var statesKey in availableStates) {
                                                                // console.log("Control ID", thingsSyncData.macId, controlID, availableStates, statesKey);
                                                                availableControl.push(new Map().set(statesKey, availableStates[statesKey]));
                                                            }
                                                        });
                                                        let control = new _models_thingControl__WEBPACK_IMPORTED_MODULE_8__["ThingControl"](thingsSyncData.macId, controlID, accessoryControlJson[controlID].type, accessoryControlJson[controlID].topicName, availableControl, accessoryId, accessoryControlJson[controlID].linkDisplayName, accessoryControlJson[controlID].iconType, accessoryControlJson[controlID].hasControlImage, accessoryControlJson[controlID].isConfirmationRequired, accessoryControlJson[controlID].linkIconType, accessoryControlJson[controlID].linkDisplayName);
                                                        thingControls.push(control);
                                                    }
                                                });
                                                // console.log("USER access", thingControls)
                                            }
                                        });
                                    }
                                }
                                if (thingsSyncData.thing.accessoriesDetails[accessoryId] != undefined) {
                                    let thingAccessory = new _models_thingAccessories__WEBPACK_IMPORTED_MODULE_6__["ThingAccessories"](thingsSyncData.macId, "", accessoryId, thingsSyncData.thing.accessoriesDetails[accessoryId].name, thingsSyncData.thing.roomName || "", thingStatus, thingControls, thingsSyncData.thing.accessoriesDetails[accessoryId].accessoryType, accessoryJson.isLinkingAvailable, accessoryJson.canChangeType, thingsSyncData.thing.accessoriesDetails[accessoryId].linkingDetails.addLinkMacId, thingsSyncData.thing.accessoriesDetails[accessoryId].linkingDetails.removeLinkMacId, thingsSyncData.thing.isLinkableThing);
                                    thingAccessories.push(thingAccessory);
                                }
                            });
                        }
                    }
                    let isOnline;
                    if (thingsSyncData.thing.status) {
                        if (thingsSyncData.thing.status.Connectivity) {
                            if (thingsSyncData.thing.status.Connectivity.Connectivity) {
                                if (thingsSyncData.thing.status.Connectivity.Connectivity ===
                                    "Offline") {
                                    isOnline = false;
                                }
                                else if (thingsSyncData.thing.status.Connectivity.Connectivity ===
                                    "Online") {
                                    isOnline = true;
                                }
                            }
                        }
                    }
                    let thingInfo;
                    if (thingsSyncData.thing.status) {
                        if (thingsSyncData.thing.status.info) {
                            thingInfo = thingsSyncData.thing.status.info;
                        }
                        else {
                            thingInfo = "";
                        }
                    }
                    else {
                        thingInfo = "";
                    }
                    let thingID, thingMacId, thingAction, thingTimeStamp, thingType, thingBuildNumber, thingCanChangeThingType, thingIsLinkableThing, thingModel, thingVersion, thingInitialModel, thingInitialVersion, thingGroupBy;
                    if (thingsSyncData) {
                        if (thingsSyncData._id) {
                            thingID = thingsSyncData._id;
                        }
                        else {
                            thingID = "";
                        }
                        if (thingsSyncData.macId) {
                            thingMacId = thingsSyncData.macId;
                        }
                        else {
                            thingMacId = "";
                        }
                        if (thingsSyncData.action) {
                            thingAction = thingsSyncData.action;
                        }
                        else {
                            thingAction = "";
                        }
                        if (thingsSyncData.timeStamp) {
                            thingTimeStamp = thingsSyncData.timeStamp;
                        }
                        else {
                            thingTimeStamp = "";
                        }
                        if (thingsSyncData.thing) {
                            if (thingsSyncData.thing.thingType) {
                                thingType = thingsSyncData.thing.thingType;
                            }
                            else {
                                thingType = "";
                            }
                            if (thingsSyncData.thing.groupBy) {
                                thingGroupBy = thingsSyncData.thing.groupBy;
                            }
                            else {
                                thingGroupBy = "";
                            }
                            if (thingsSyncData.thing.buildNumber) {
                                thingBuildNumber = thingsSyncData.thing.buildNumber;
                            }
                            else {
                                thingBuildNumber = 0;
                            }
                            if (thingsSyncData.thing.canChangeThingType) {
                                thingCanChangeThingType = thingsSyncData.thing.canChangeThingType;
                            }
                            else {
                                thingCanChangeThingType = "";
                            }
                            if (thingsSyncData.thing.isLinkableThing) {
                                thingIsLinkableThing = thingsSyncData.thing.isLinkableThing;
                            }
                            else {
                                thingIsLinkableThing = "";
                            }
                            if (thingsSyncData.thing.model) {
                                thingModel = thingsSyncData.thing.model;
                            }
                            else {
                                thingModel = "";
                            }
                            if (thingsSyncData.thing.version) {
                                thingVersion = thingsSyncData.thing.version;
                            }
                            else {
                                thingVersion = "";
                            }
                            if (thingsSyncData.thing.isLinkableThing != null) {
                                thingIsLinkableThing = thingsSyncData.thing.isLinkableThing;
                            }
                            else {
                                thingIsLinkableThing = "";
                            }
                            if (thingsSyncData.thing.accessoriesDetails) {
                                if (thingsSyncData.thing.accessoriesDetails.initialModel) {
                                    thingInitialModel =
                                        thingsSyncData.thing.accessoriesDetails.initialModel;
                                }
                                else {
                                    thingInitialModel = "";
                                }
                                if (thingsSyncData.thing.accessoriesDetails.initialVersion) {
                                    thingInitialVersion =
                                        thingsSyncData.thing.accessoriesDetails.initialVersion;
                                }
                                else {
                                    thingInitialVersion = "";
                                }
                            }
                        }
                    }
                    {
                        let thing = new _models_thing__WEBPACK_IMPORTED_MODULE_1__["Thing"](thingID, thingMacId, thingID, thingAction, thingType, thingGroupBy, thingTimeStamp, thingBuildNumber, thingLocation, thingsSyncData.thing.roomName || "", thingAccessories, thingInfo, admin, thingUserAccess, isOnline, thingManufactureDetails, true, false, thingCanChangeThingType, thingIsLinkableThing, thingModel, thingVersion, thingInitialModel, thingInitialVersion);
                        if (thing.action == "update" || thing.action == "insert") {
                            this.dbService.update('Things', { macId: thingsSyncData.macId, thing: thing }).then(() => {
                            });
                        }
                    }
                }
            }
        });
        this.missionService.announceMission("DataSaved");
    }
    getAllThingData() {
        this.thingUIObject.clear();
        this.dbService.getAll('Things').then(allThingData => {
            allThingData.forEach(thing => thing['thing']['accessories'].forEach(accessory => {
                if (accessory.statusList) {
                    if (accessory.statusList.length != 0) {
                        if (accessory.statusList.length > 1) {
                            accessory.statusList.forEach(status => {
                                var controlTopic;
                                var currentStates;
                                var imageUrl = "https://cogcons-things.s3.ap-south-1.amazonaws.com/things/";
                                var checkPower = status.statusId;
                                if (checkPower == "power") {
                                    status.currentState.forEach(states => {
                                        states.forEach(state => {
                                            currentStates = state;
                                        });
                                    });
                                    if (status.hasStatusImage && currentStates.length > 0) {
                                        imageUrl =
                                            imageUrl +
                                                thing['thing']['manufacturerDetails'].manufacturer +
                                                "/" +
                                                accessory.accessoryType +
                                                "/" +
                                                status.iconType +
                                                "/" +
                                                currentStates +
                                                ".png";
                                    }
                                    else {
                                        imageUrl =
                                            imageUrl +
                                                thing['thing']['manufacturerDetails'].manufacturer +
                                                "/" +
                                                accessory.accessoryType +
                                                "/" +
                                                status.iconType +
                                                ".png";
                                    }
                                    if (accessory.thingControl.length != 0) {
                                        accessory.thingControl.forEach(control => {
                                            if (control.controlIdentifier == "power") {
                                                controlTopic = control.topic;
                                            }
                                        });
                                    }
                                    let thingUiObject = new _models_thingUiObject__WEBPACK_IMPORTED_MODULE_11__["ThingUiObject"](thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing['thing'].macId, thing['thing'].buildNumber, imageUrl.toLowerCase().replace(/ /g, "_"), accessory.thingName, thing['thing'].thingsLocation.placeType, thing['thing'].isNewlyAdded, thing['thing'].isOnline, currentStates, status.topic, controlTopic, thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName);
                                    this.thingUIObject.set(thing['thing'].macId + "/" + accessory.accessoryIdentifier, thingUiObject);
                                    this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject });
                                }
                            });
                        }
                        else {
                            var controlTopic;
                            var currentStates;
                            var imageUrl = "https://cogcons-things.s3.ap-south-1.amazonaws.com/things/";
                            if (accessory.statusList[0]) {
                                {
                                    if (accessory.statusList[0].currentState[0]) {
                                        accessory.statusList[0].currentState[0].forEach(states => {
                                            currentStates = states;
                                        });
                                    }
                                }
                                if (accessory.statusList[0].hasStatusImage) {
                                    imageUrl =
                                        imageUrl +
                                            thing['thing'].manufacturerDetails.manufacturer +
                                            "/" +
                                            accessory.accessoryType +
                                            "/" +
                                            accessory.statusList[0].iconType +
                                            "/" +
                                            currentStates +
                                            ".png";
                                }
                                else {
                                    imageUrl =
                                        imageUrl +
                                            thing['thing'].manufacturerDetails.manufacturer +
                                            "/" +
                                            accessory.accessoryType +
                                            "/" +
                                            accessory.statusList[0].iconType +
                                            ".png";
                                }
                                if (accessory.thingControl[0] != undefined) {
                                    controlTopic = accessory.thingControl[0].topic;
                                }
                                let thingUiObject = new _models_thingUiObject__WEBPACK_IMPORTED_MODULE_11__["ThingUiObject"](thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing['thing'].macId, thing['thing'].buildNumber, imageUrl.toLowerCase().replace(/ /g, "_"), accessory.thingName, thing['thing'].thingsLocation.placeType, thing['thing'].isNewlyAdded, thing['thing'].isOnline, currentStates, accessory.statusList[0].topic, controlTopic, thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName);
                                this.thingUIObject.set(thing['thing'].macId + "/" + accessory.accessoryIdentifier, thingUiObject);
                                this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject });
                            }
                            else if (thing['thing'].thingType === "laptop") {
                                if (accessory.statusList.lock) {
                                    if (accessory.statusList.lock.currentStatus[0].lock[0] ===
                                        "UNLOCK") {
                                        imageUrl =
                                            imageUrl + "cogcons_pvt_ltd/laptop/power/off.png";
                                    }
                                    else if (accessory.statusList.lock.currentStatus[0].lock[0] ===
                                        "LOCK") {
                                        imageUrl =
                                            imageUrl + "cogcons_pvt_ltd/laptop/power/on.png";
                                    }
                                }
                                if (accessory.thingControl[0] != undefined) {
                                    controlTopic = accessory.thingControl[0].topic;
                                }
                                let thingUiObject = new _models_thingUiObject__WEBPACK_IMPORTED_MODULE_11__["ThingUiObject"](thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing['thing'].macId, thing['thing'].buildNumber, imageUrl.toLowerCase(), accessory.thingName, thing['thing'].thingsLocation.placeType, thing['thing'].isNewlyAdded, thing['thing'].isOnline, currentStates, accessory.statusList.lock.topic, controlTopic, thing['thing'].thingsLocation.placeName + "-" + thing['thing'].roomName);
                                this.thingUIObject.set(thing['thing'].macId + "/" + accessory.accessoryIdentifier, thingUiObject);
                                this.dbService.update('thingUiObject', { uiMacId: thing['thing'].macId + "/" + accessory.accessoryIdentifier, thing: thingUiObject });
                            }
                        }
                    }
                }
            }));
        });
        this.missionService.announceMission("ThingsUpdated");
    }
    deleteDatabase() {
        console.log("in delete");
        this.dbService.clear('Things').then(() => {
            console.log("THINGS");
            this.missionService.announceMission("ThingsCleared");
        }, error => {
            console.log(error);
        });
        this.missionService.missionAnnounced$.subscribe(mission => {
            if (mission === "ThingsCleared") {
                console.log("THING UI OBJECT");
                this.dbService.clear('thingUiObject').then(() => {
                    this.missionService.announceMission("UiCleared");
                }, error => {
                    console.log(error);
                });
            }
        });
        this.missionService.missionAnnounced$.subscribe(mission => {
            if (mission === "ThingsCleared") {
                console.log("NAME SET OBJECT");
                this.dbService.clear('locationList').then(() => {
                    console.log("deleted");
                }, error => {
                    console.log(error);
                });
            }
        });
    }
};
DataStore.ctorParameters = () => [
    { type: _authentication_service__WEBPACK_IMPORTED_MODULE_9__["AuthenticationService"] },
    { type: _mission_service__WEBPACK_IMPORTED_MODULE_10__["MissionService"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_12__["NgxIndexedDBService"] }
];
DataStore = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_authentication_service__WEBPACK_IMPORTED_MODULE_9__["AuthenticationService"],
        _mission_service__WEBPACK_IMPORTED_MODULE_10__["MissionService"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_12__["NgxIndexedDBService"]])
], DataStore);



/***/ }),

/***/ "./src/app/_services/http.service.ts":
/*!*******************************************!*\
  !*** ./src/app/_services/http.service.ts ***!
  \*******************************************/
/*! exports provided: HTTPCallsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTTPCallsService", function() { return HTTPCallsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let HTTPCallsService = class HTTPCallsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getThingData(pageNo) {
        let query = {
            pageNo: pageNo,
            size: 50
        };
        return this.httpClient.get("https://dev.cogcons.com/api/synchronization/thingsDataSync?pageNo=" +
            query.pageNo +
            "&size=" +
            query.size);
    }
    mqttPublish(topic, payload, clientId) {
        let body = {
            topic: topic,
            payload: payload,
            retain: false,
            clientId: clientId
        };
        console.log(body);
        return this.httpClient.post("https://dev.cogcons.com/api/users/dashboardMqttData", body);
    }
    getProfileIcon(phonenumber) {
        return this.httpClient.get("https://dev.cogcons.com/api/users/profile_pic/" + phonenumber, { responseType: 'blob' })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])(response => this.readFile(response)));
    }
    readFile(blob) {
        return rxjs__WEBPACK_IMPORTED_MODULE_3__["Observable"].create(obs => {
            const reader = new FileReader();
            reader.onerror = err => obs.error(err);
            reader.onabort = err => obs.error(err);
            reader.onload = () => obs.next(reader.result);
            reader.onloadend = () => obs.complete();
            return reader.readAsDataURL(blob);
        });
    }
};
HTTPCallsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
HTTPCallsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"]])
], HTTPCallsService);



/***/ }),

/***/ "./src/app/_services/index.ts":
/*!************************************!*\
  !*** ./src/app/_services/index.ts ***!
  \************************************/
/*! exports provided: dbrouting, DataStore, AlertService, AuthenticationService, MissionService, ThingsSyncService, HTTPCallsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.service */ "./src/app/_services/alert.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return _alert_service__WEBPACK_IMPORTED_MODULE_1__["AlertService"]; });

/* harmony import */ var _authentication_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./authentication.service */ "./src/app/_services/authentication.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return _authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"]; });

/* harmony import */ var _mission_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mission.service */ "./src/app/_services/mission.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MissionService", function() { return _mission_service__WEBPACK_IMPORTED_MODULE_3__["MissionService"]; });

/* harmony import */ var _thingsSync_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./thingsSync.service */ "./src/app/_services/thingsSync.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ThingsSyncService", function() { return _thingsSync_service__WEBPACK_IMPORTED_MODULE_4__["ThingsSyncService"]; });

/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./http.service */ "./src/app/_services/http.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HTTPCallsService", function() { return _http_service__WEBPACK_IMPORTED_MODULE_5__["HTTPCallsService"]; });

/* harmony import */ var _dataStore_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dataStore.service */ "./src/app/_services/dataStore.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dbrouting", function() { return _dataStore_service__WEBPACK_IMPORTED_MODULE_6__["dbrouting"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataStore", function() { return _dataStore_service__WEBPACK_IMPORTED_MODULE_6__["DataStore"]; });










/***/ }),

/***/ "./src/app/_services/mission.service.ts":
/*!**********************************************!*\
  !*** ./src/app/_services/mission.service.ts ***!
  \**********************************************/
/*! exports provided: MissionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MissionService", function() { return MissionService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");



let MissionService = class MissionService {
    constructor() {
        // Observable string sources
        this.missionAnnouncedSource = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.missionConfirmedSource = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        // Observable string streams
        this.missionAnnounced$ = this.missionAnnouncedSource.asObservable();
        this.missionConfirmed$ = this.missionConfirmedSource.asObservable();
    }
    // Service message commands
    announceMission(mission) {
        this.missionAnnouncedSource.next(mission);
    }
    confirmMission(astronaut) {
        this.missionConfirmedSource.next(astronaut);
    }
};
MissionService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], MissionService);



/***/ }),

/***/ "./src/app/_services/thingsSync.service.ts":
/*!*************************************************!*\
  !*** ./src/app/_services/thingsSync.service.ts ***!
  \*************************************************/
/*! exports provided: ThingsSyncService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingsSyncService", function() { return ThingsSyncService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./http.service */ "./src/app/_services/http.service.ts");
/* harmony import */ var _alert_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./alert.service */ "./src/app/_services/alert.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _mission_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mission.service */ "./src/app/_services/mission.service.ts");
/* harmony import */ var _dataStore_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dataStore.service */ "./src/app/_services/dataStore.service.ts");






let ThingsSyncService = class ThingsSyncService {
    constructor(httpService, alertService, missionService, dataStore) {
        this.httpService = httpService;
        this.alertService = alertService;
        this.missionService = missionService;
        this.dataStore = dataStore;
        this.displayModel = "none";
        this.oldStatus = "";
        this.isSync = false;
        this.missions = ["ThingSyncCompleted"];
        this.noOfPages = 1;
        this.pageCount = 1;
        this.storeArray = [];
    }
    syncThingsData(pageCount) {
        this.pageCount = pageCount;
        this.httpService.getThingData(this.pageCount).subscribe(syncData => {
            var syncDataArray = Object.keys(syncData["data"]).map(function (valueIndex) {
                let data = syncData["data"][valueIndex];
                return data;
            });
            this.storeArray = this.storeArray.concat(syncDataArray);
            this.noOfPages = syncData["totalPages"];
            if (this.noOfPages != this.pageCount) {
                this.pageCount = this.pageCount + 1;
                this.syncThingsData(this.pageCount);
            }
            else {
                // console.log("Data before storage", this.storeArray);
                this.dataStore.parseThingData(this.storeArray);
                this.storeArray = [];
            }
        });
        return true;
    }
};
ThingsSyncService.ctorParameters = () => [
    { type: _http_service__WEBPACK_IMPORTED_MODULE_1__["HTTPCallsService"] },
    { type: _alert_service__WEBPACK_IMPORTED_MODULE_2__["AlertService"] },
    { type: _mission_service__WEBPACK_IMPORTED_MODULE_4__["MissionService"] },
    { type: _dataStore_service__WEBPACK_IMPORTED_MODULE_5__["DataStore"] }
];
ThingsSyncService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_http_service__WEBPACK_IMPORTED_MODULE_1__["HTTPCallsService"],
        _alert_service__WEBPACK_IMPORTED_MODULE_2__["AlertService"],
        _mission_service__WEBPACK_IMPORTED_MODULE_4__["MissionService"],
        _dataStore_service__WEBPACK_IMPORTED_MODULE_5__["DataStore"]])
], ThingsSyncService);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: routing */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routing", function() { return routing; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./login */ "./src/app/login/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./_helpers */ "./src/app/_helpers/index.ts");
/* harmony import */ var _dashboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dashboard */ "./src/app/dashboard/index.ts");
/* harmony import */ var _dashboard_things__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dashboard/things */ "./src/app/dashboard/things/index.ts");
/* harmony import */ var _dashboard_access_access_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dashboard/access/access.component */ "./src/app/dashboard/access/access.component.ts");
/* harmony import */ var _dashboard_settings_settings_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./dashboard/settings/settings.component */ "./src/app/dashboard/settings/settings.component.ts");
/* harmony import */ var _dashboard_things_thing_settings_thing_settings_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dashboard/things/thing-settings/thing-settings.component */ "./src/app/dashboard/things/thing-settings/thing-settings.component.ts");
/* harmony import */ var _dashboard_things_thing_settings_thing_settings_edit_thing_settings_edit_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.ts");










const routes = [
    {
        path: "dashboard",
        component: _dashboard__WEBPACK_IMPORTED_MODULE_4__["DashboardComponent"],
        canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]],
        children: [
            {
                path: "things",
                component: _dashboard_things__WEBPACK_IMPORTED_MODULE_5__["ThingsComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            },
            {
                path: "thingDetails/:id/:accessoryId",
                component: _dashboard_things_thing_settings_thing_settings_component__WEBPACK_IMPORTED_MODULE_8__["ThingSettingsComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            },
            {
                path: "access",
                component: _dashboard_access_access_component__WEBPACK_IMPORTED_MODULE_6__["AccessComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            },
            {
                path: "settings",
                component: _dashboard_settings_settings_component__WEBPACK_IMPORTED_MODULE_7__["SettingsComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            },
            {
                path: "edit/:id",
                component: _dashboard_things_thing_settings_thing_settings_edit_thing_settings_edit_component__WEBPACK_IMPORTED_MODULE_9__["ThingSettingsEditComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            },
            {
                path: "things/:label",
                component: _dashboard_things__WEBPACK_IMPORTED_MODULE_5__["ThingsComponent"],
                canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_3__["AuthGuard"]]
            }
        ]
    },
    {
        path: "**",
        component: _login__WEBPACK_IMPORTED_MODULE_2__["LoginComponent"]
    }
];
const routing = _angular_router__WEBPACK_IMPORTED_MODULE_1__["RouterModule"].forRoot(routes, {
    useHash: true
});


/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = "dashboard";
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/expansion */ "./node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./_services */ "./src/app/_services/index.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./_helpers */ "./src/app/_helpers/index.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ngx-bootstrap */ "./node_modules/ngx-bootstrap/esm5/ngx-bootstrap.js");
/* harmony import */ var ng2_tel_input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ng2-tel-input */ "./node_modules/ng2-tel-input/ng2-tel-input.js");
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./login */ "./src/app/login/index.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./dashboard/dashboard.component */ "./src/app/dashboard/dashboard.component.ts");
/* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./_components */ "./src/app/_components/index.ts");
/* harmony import */ var ngx_ui_switch__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ngx-ui-switch */ "./node_modules/ngx-ui-switch/ui-switch.es2015.js");
/* harmony import */ var _dashboard_access_access_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./dashboard/access/access.component */ "./src/app/dashboard/access/access.component.ts");
/* harmony import */ var _dashboard_things_things_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./dashboard/things/things.component */ "./src/app/dashboard/things/things.component.ts");
/* harmony import */ var _dashboard_settings_settings_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./dashboard/settings/settings.component */ "./src/app/dashboard/settings/settings.component.ts");
/* harmony import */ var _dashboard_things_thing_settings_thing_settings_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./dashboard/things/thing-settings/thing-settings.component */ "./src/app/dashboard/things/thing-settings/thing-settings.component.ts");
/* harmony import */ var _helpers_replace_pipe__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./_helpers/replace.pipe */ "./src/app/_helpers/replace.pipe.ts");
/* harmony import */ var _angular_material_slider__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/slider */ "./node_modules/@angular/material/esm2015/slider.js");
/* harmony import */ var _dashboard_things_thing_settings_thing_settings_edit_thing_settings_edit_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.ts");
/* harmony import */ var _services_dataStore_service__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./_services/dataStore.service */ "./src/app/_services/dataStore.service.ts");
/* harmony import */ var _dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./dashboard/things/msater-control/msater-control.component */ "./src/app/dashboard/things/msater-control/msater-control.component.ts");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _dashboard_things_thing_settings_thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.ts");
































let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["ReactiveFormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClientModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_8__["routing"],
            ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__["BsDropdownModule"].forRoot(),
            ng2_tel_input__WEBPACK_IMPORTED_MODULE_12__["Ng2TelInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatSidenavModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatIconModule"],
            _angular_material_slider__WEBPACK_IMPORTED_MODULE_24__["MatSliderModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__["BrowserAnimationsModule"],
            _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_16__["LayoutModule"],
            ngx_ui_switch__WEBPACK_IMPORTED_MODULE_18__["UiSwitchModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_6__["MatExpansionModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_30__["MatDialogModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_29__["MatFormFieldModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_28__["MatInputModule"],
            _services_dataStore_service__WEBPACK_IMPORTED_MODULE_26__["dbrouting"]
        ],
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_10__["AppComponent"],
            _login__WEBPACK_IMPORTED_MODULE_13__["LoginComponent"],
            _dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_15__["DashboardComponent"],
            _components__WEBPACK_IMPORTED_MODULE_17__["AlertComponent"],
            _dashboard_access_access_component__WEBPACK_IMPORTED_MODULE_19__["AccessComponent"],
            _dashboard_things_things_component__WEBPACK_IMPORTED_MODULE_20__["ThingsComponent"],
            _dashboard_settings_settings_component__WEBPACK_IMPORTED_MODULE_21__["SettingsComponent"],
            _dashboard_things_thing_settings_thing_settings_component__WEBPACK_IMPORTED_MODULE_22__["ThingSettingsComponent"],
            _helpers_replace_pipe__WEBPACK_IMPORTED_MODULE_23__["ReplacePipe"],
            _dashboard_things_thing_settings_thing_settings_edit_thing_settings_edit_component__WEBPACK_IMPORTED_MODULE_25__["ThingSettingsEditComponent"],
            _dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_27__["MsaterControlComponent"],
            _dashboard_things_thing_settings_thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_31__["AddNumberDialogComponent"]
        ],
        providers: [
            _services__WEBPACK_IMPORTED_MODULE_7__["AlertService"],
            _services__WEBPACK_IMPORTED_MODULE_7__["MissionService"],
            _services__WEBPACK_IMPORTED_MODULE_7__["ThingsSyncService"],
            _services__WEBPACK_IMPORTED_MODULE_7__["HTTPCallsService"],
            _services__WEBPACK_IMPORTED_MODULE_7__["DataStore"],
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HTTP_INTERCEPTORS"], useClass: _helpers__WEBPACK_IMPORTED_MODULE_9__["JwtInterceptor"], multi: true }
            // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
        ],
        entryComponents: [_dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_27__["MsaterControlComponent"], _dashboard_things_thing_settings_thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_31__["AddNumberDialogComponent"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_10__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/dashboard/access/access.component.css":
/*!*******************************************************!*\
  !*** ./src/app/dashboard/access/access.component.css ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Rhc2hib2FyZC9hY2Nlc3MvYWNjZXNzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/dashboard/access/access.component.ts":
/*!******************************************************!*\
  !*** ./src/app/dashboard/access/access.component.ts ***!
  \******************************************************/
/*! exports provided: AccessComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessComponent", function() { return AccessComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AccessComponent = class AccessComponent {
    constructor() { }
    ngOnInit() {
    }
};
AccessComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-access',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./access.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/access/access.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./access.component.css */ "./src/app/dashboard/access/access.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AccessComponent);



/***/ }),

/***/ "./src/app/dashboard/dashboard.component.css":
/*!***************************************************!*\
  !*** ./src/app/dashboard/dashboard.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".sidenav-container {\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: #121214;\n}\n\n.sidenav {\n  width: 250px;\n  background: #000;\n}\n\n.sidenav {\n  background-image: linear-gradient(171deg, #1c1c21 76%, #333131 108%);\n}\n\n.mat-toolbar {\n  background-color: #1c1c21;\n  height: 80px;\n}\n\n.mat-toolbar.mat-primary {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #2c2c2b;\n}\n\na,\nspan,\n.mat-toolbar,\n.sidenav {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 30px;\n}\n\n.ccSpace {\n  /* This fills the remaining space, by using flexbox.  */\n  /* Every toolbar row uses a flexbox row layout. */\n  flex: 1 1 auto;\n}\n\n.btn-secondary {\n  background-color: #000;\n}\n\n.ccNestedItems {\n  margin-left: 30px;\n}\n\n.ccAllDeviceIcon {\n  color: #f49664;\n}\n\n.ccUserName {\n  font-size: 70%;\n  font-family: Roboto;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: right;\n  color: #7882a2;\n  margin-left: 25px;\n  margin-top: 30px;\n}\n\n.form-control {\n  margin: auto;\n}\n\n.ccNotificationIcon {\n  color: #7882a2;\n  border: none;\n}\n\n.ccNotificationIcon :hover{\n  color: #ffff;\n  border: none;\n}\n\n.ccNotificationIconSize  {\n  font-size: 40px;\n}\n\n.ccNotificationIconSize :hover  {\n  font-size: 40px;\n  color: #ffff;\n}\n\n.ccTabIcon {\n  border: none;\n\n  background: none;\n}\n\n.ccAddIcon {\n  margin-left: 5px;\n  height: 30px;\n  width: 30px;\n}\n\n.ccSearchBar {\n  margin-right: 40px;\n  border-radius: 50px;\n  margin-left: 40px;\n}\n\n.ccProfilePicture {\n  margin-top: 30px;\n  border-radius: 100%;\n  border-color: white;\n  height: 60px;\n  width: 60px;\n  background: #2c2c2b;\n}\n\n.ccNavBarContentSpacing {\n  margin-top: 20px;\n}\n\n.ccNavbarIcon {\n  margin-right: 5px;\n}\n\n.ccLoading {\n  width: 105px;\n  margin-top: 10px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dashboard/dashboard.component.ts":
/*!**************************************************!*\
  !*** ./src/app/dashboard/dashboard.component.ts ***!
  \**************************************************/
/*! exports provided: DashboardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardComponent", function() { return DashboardComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
/* harmony import */ var rxjs_Rx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/Rx */ "./node_modules/rxjs-compat/_esm2015/Rx.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_thingsSync_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/_services/thingsSync.service */ "./src/app/_services/thingsSync.service.ts");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../_services/http.service */ "./src/app/_services/http.service.ts");











let DashboardComponent = class DashboardComponent {
    constructor(breakpointObserver, authenticationService, missionService, thingSyncService, router, dataStore, dbService, httpService) {
        this.breakpointObserver = breakpointObserver;
        this.authenticationService = authenticationService;
        this.missionService = missionService;
        this.thingSyncService = thingSyncService;
        this.router = router;
        this.dataStore = dataStore;
        this.dbService = dbService;
        this.httpService = httpService;
        this.placeNameSet = new Set();
        this.isHandset$ = this.breakpointObserver
            .observe(_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_2__["Breakpoints"].Handset)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(result => result.matches));
    }
    close() {
        this.sidenav.close();
    }
    ngOnInit() {
        this.name();
        this.placeNameSet.clear();
        this.refreshData();
        this.loading = true;
        this.thingSyncService.syncThingsData(1);
        this.missionService.missionAnnounced$.subscribe(mission => {
            switch (mission) {
                case "LocationListFramed":
                    this.name();
                    break;
            }
        });
        let name = JSON.parse(localStorage.getItem("currentUser"));
        this.userName = name["userName"];
        this.getProfilePicture(name["phoneNumber"]);
    }
    onSearchChange(searchValue) {
        this.getPlaceNameDevices(searchValue.toLowerCase());
    }
    refreshData() {
        this.thingSyncService.syncThingsData(1);
        this.subscribeToData();
    }
    subscribeToData() {
        this.timerSubscription = rxjs_Rx__WEBPACK_IMPORTED_MODULE_3__["Observable"].timer(3000)
            .first()
            .subscribe(() => { this.refreshData(); });
    }
    name() {
        this.dbService.getAll('locationList').then(data => {
            data.forEach(element => {
                if (element['name'] != "")
                    this.placeNameSet.add(element['name']);
            });
            this.loading = false;
        });
    }
    getPlaceNameDevices(placeName) {
        this.router.navigate(["/dashboard/things/" + placeName]);
        this.missionService.announceMission("sort!#!" + placeName);
    }
    navigateTo(routesID) {
        // console.log("Navigating to ", routesID);
        switch (routesID) {
            case "things":
                this.router.navigate(["/dashboard/things"]);
                this.missionService.announceMission("removeSort");
                break;
            case "access":
                this.router.navigate(["/dashboard/access"]);
                break;
            case "settings":
                this.router.navigate(["/dashboard/settings"]);
                break;
            case "logout":
                this.authenticationService.logout();
                break;
        }
    }
    logout() {
        this.loading = false;
        this.authenticationService.logout();
    }
    getProfilePicture(phoneNumber) {
        this.httpService.getProfileIcon(phoneNumber).subscribe((data) => {
            this.data = data;
        }, (error) => {
            console.log('Error ', error);
        });
    }
    ngOnDestroy() {
        this.timerSubscription.unsubscribe();
        this.timerCheck = rxjs_Rx__WEBPACK_IMPORTED_MODULE_3__["Observable"].timer(10000).first()
            .subscribe(() => {
            this.timerSubscription.unsubscribe();
            this.dataStore.deleteDatabase();
        });
    }
};
DashboardComponent.ctorParameters = () => [
    { type: _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_2__["BreakpointObserver"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["MissionService"] },
    { type: src_app_services_thingsSync_service__WEBPACK_IMPORTED_MODULE_7__["ThingsSyncService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["DataStore"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_8__["NgxIndexedDBService"] },
    { type: _services_http_service__WEBPACK_IMPORTED_MODULE_10__["HTTPCallsService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('sidenav', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_9__["MatSidenav"])
], DashboardComponent.prototype, "sidenav", void 0);
DashboardComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-dashboard",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dashboard.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/dashboard.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dashboard.component.css */ "./src/app/dashboard/dashboard.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_cdk_layout__WEBPACK_IMPORTED_MODULE_2__["BreakpointObserver"],
        _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"],
        _services__WEBPACK_IMPORTED_MODULE_5__["MissionService"],
        src_app_services_thingsSync_service__WEBPACK_IMPORTED_MODULE_7__["ThingsSyncService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"],
        _services__WEBPACK_IMPORTED_MODULE_5__["DataStore"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_8__["NgxIndexedDBService"],
        _services_http_service__WEBPACK_IMPORTED_MODULE_10__["HTTPCallsService"]])
], DashboardComponent);



/***/ }),

/***/ "./src/app/dashboard/index.ts":
/*!************************************!*\
  !*** ./src/app/dashboard/index.ts ***!
  \************************************/
/*! exports provided: DashboardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _dashboard_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dashboard.component */ "./src/app/dashboard/dashboard.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DashboardComponent", function() { return _dashboard_component__WEBPACK_IMPORTED_MODULE_1__["DashboardComponent"]; });





/***/ }),

/***/ "./src/app/dashboard/settings/settings.component.css":
/*!***********************************************************!*\
  !*** ./src/app/dashboard/settings/settings.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Rhc2hib2FyZC9zZXR0aW5ncy9zZXR0aW5ncy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/dashboard/settings/settings.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/dashboard/settings/settings.component.ts ***!
  \**********************************************************/
/*! exports provided: SettingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingsComponent", function() { return SettingsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SettingsComponent = class SettingsComponent {
    constructor() { }
    ngOnInit() {
    }
};
SettingsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-settings',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./settings.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/settings/settings.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./settings.component.css */ "./src/app/dashboard/settings/settings.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], SettingsComponent);



/***/ }),

/***/ "./src/app/dashboard/things/index.ts":
/*!*******************************************!*\
  !*** ./src/app/dashboard/things/index.ts ***!
  \*******************************************/
/*! exports provided: ThingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _things_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./things.component */ "./src/app/dashboard/things/things.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ThingsComponent", function() { return _things_component__WEBPACK_IMPORTED_MODULE_1__["ThingsComponent"]; });





/***/ }),

/***/ "./src/app/dashboard/things/msater-control/msater-control.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/dashboard/things/msater-control/msater-control.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ccOnDevice{\n    margin: 5px;\n    border: 2px green solid;\n    border-radius: 20px;\n    text-align: center;\n    font-size:12px;\n    outline: none;\n}\n.ccOffDevices{\n    margin:5px;\n    border: 2px red solid;\n    border-radius: 20px;\n    font-size:12px;\n    text-align: center;\n    outline: none;\n    \n}\n.ccSpacing{\n    margin: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZGFzaGJvYXJkL3RoaW5ncy9tc2F0ZXItY29udHJvbC9tc2F0ZXItY29udHJvbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztJQUNYLHVCQUF1QjtJQUN2QixtQkFBbUI7SUFDbkIsa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCxhQUFhO0FBQ2pCO0FBQ0E7SUFDSSxVQUFVO0lBQ1YscUJBQXFCO0lBQ3JCLG1CQUFtQjtJQUNuQixjQUFjO0lBQ2Qsa0JBQWtCO0lBQ2xCLGFBQWE7O0FBRWpCO0FBQ0E7SUFDSSxZQUFZO0FBQ2hCIiwiZmlsZSI6InNyYy9hcHAvZGFzaGJvYXJkL3RoaW5ncy9tc2F0ZXItY29udHJvbC9tc2F0ZXItY29udHJvbC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNjT25EZXZpY2V7XG4gICAgbWFyZ2luOiA1cHg7XG4gICAgYm9yZGVyOiAycHggZ3JlZW4gc29saWQ7XG4gICAgYm9yZGVyLXJhZGl1czogMjBweDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgZm9udC1zaXplOjEycHg7XG4gICAgb3V0bGluZTogbm9uZTtcbn1cbi5jY09mZkRldmljZXN7XG4gICAgbWFyZ2luOjVweDtcbiAgICBib3JkZXI6IDJweCByZWQgc29saWQ7XG4gICAgYm9yZGVyLXJhZGl1czogMjBweDtcbiAgICBmb250LXNpemU6MTJweDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgICBcbn1cbi5jY1NwYWNpbmd7XG4gICAgbWFyZ2luOiAxMHB4O1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/dashboard/things/msater-control/msater-control.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/dashboard/things/msater-control/msater-control.component.ts ***!
  \*****************************************************************************/
/*! exports provided: MsaterControlComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MsaterControlComponent", function() { return MsaterControlComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");




let MsaterControlComponent = class MsaterControlComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() { }
    onNoClick() {
        this.dialogRef.close();
    }
    masterControl(status) {
        this.masterStatus = status;
        console.log(this.masterStatus);
    }
};
MsaterControlComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
MsaterControlComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-msater-control',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./msater-control.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/msater-control/msater-control.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./msater-control.component.css */ "./src/app/dashboard/things/msater-control/msater-control.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object])
], MsaterControlComponent);



/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.css":
/*!***********************************************************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.css ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Rhc2hib2FyZC90aGluZ3MvdGhpbmctc2V0dGluZ3MvdGhpbmctc2V0dGluZ3MtZWRpdC9hZGQtbnVtYmVyLWRpYWxvZy9hZGQtbnVtYmVyLWRpYWxvZy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.ts":
/*!**********************************************************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.ts ***!
  \**********************************************************************************************************************/
/*! exports provided: AddNumberDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddNumberDialogComponent", function() { return AddNumberDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");




let AddNumberDialogComponent = class AddNumberDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() { }
    onNoClick() {
        this.dialogRef.close();
    }
};
AddNumberDialogComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] }
];
AddNumberDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-add-number-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-number-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-number-dialog.component.css */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object])
], AddNumberDialogComponent);



/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.css":
/*!*******************************************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.css ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ccThingSettingEditToolbar {\n  background-color: #fdfdfd;\n}\n.noGutter {\n  margin-left: 0;\n  margin-right: 0;\n}\n.ccDeviceLocation {\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n\n  text-align: center;\n  color: #484646;\n}\n.ccColor {\n  color: black;\n}\n.ccDeviceLocationDevice {\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  margin-top: 20px;\n\n  text-align: center;\n  color: #484646;\n}\n.ccCardHeaderColor {\n  color: #f49664;\n  /* color: #0047d6; */\n}\n.ccDeviceDropDown {\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  margin-left: 600px;\n  color: #151411;\n}\n.ccSpacing {\n  margin-top: 10px;\n}\n.ccBorderCheck {\n  border: none;\n}\n.ccDropDown {\n  height: 10px;\n  width: 12px;\n  border: none;\n  margin-left: 10px;\n}\n.ccDropDownDeviceTyoe {\n  height: 10px;\n  width: 12px;\n  border: none;\n  margin-left: 10px;\n  margin-top: 5px;\n}\n.ccCardSpacing {\n  margin: 5px;\n  padding-left: 27px;\n}\n.ccAccessoryEditCard {\n  height: 260px;\n  width: 330px;\n  background: #353538;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n.ccToolbarTitle {\n  margin-top: 20px;\n\n  font-family: Roboto;\n  font-size: 21px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n\n  color: #484646;\n}\n.ccToolBarDropDownRoomName {\n  font-family: Roboto;\n  font-size: 21px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  /* margin-left: 35%; */\n  color: #151411;\n}\n.ccToolBarDropDown {\n  font-family: Roboto;\n  font-size: 21px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n\n  color: #151411;\n}\n.ccThingImageContainer {\n  border-radius: 100%;\n  background-color: black;\n  height: 75px;\n  width: 75px;\n  border-color: white;\n  padding: 15px;\n}\n.ccCardTitle {\n  margin-left: 10px;\n  font-family: Roboto;\n  font-size: 13.7px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.37;\n  letter-spacing: 0.19px;\n  text-align: left;\n  color: #ffffff;\n}\n.ccCardFooter {\n  font-family: Roboto;\n  font-size: 13.7px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.37;\n  letter-spacing: 0.19px;\n  text-align: left;\n  color: #ffffff;\n}\n.ccdeviceTypeName {\n  margin-top: 7px;\n  background: none;\n  background-image: none;\n  border: none;\n  font-size: 20px;\n  color: white;\n}\n.ccdeviceTypeName:hover {\n  color: #f49664;\n}\n.ccDropDownPosition {\n  margin-left: 30px;\n  position: relative;\n  z-index: 1000;\n}\n.ccThingImage {\n  height: 55px;\n  width: 55px;\n}\n.ccDropDownLength {\n  height: 259px;\n  overflow: auto;\n}\n.ccSaveIcon {\n  margin-top: 20px;\n  margin-right: 20px;\n  height: 60px;\n  width: 60px;\n}\n.ccTabIcon {\n  margin-left: 50px;\n}\n.ccBackIcon {\n  width: 25px;\n  height: 20px;\n  margin-top: 25px;\n  margin-left: 10px;\n  cursor: pointer;\n  margin-right: 50px;\n}\n.ccPinIcon {\n  padding-top: 10px;\n  height: 60px;\n  width: 60px;\n  text-align: end;\n}\n.ccToolbarTitleRoomName {\n  margin-top: 20px;\n  /* margin-left: 30px; */\n  font-family: Roboto;\n  font-size: 21px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n\n  color: #484646;\n}\n.ccLoading {\n  width: 105px;\n  margin-top: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.ts":
/*!******************************************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.ts ***!
  \******************************************************************************************************/
/*! exports provided: ThingSettingsEditComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingSettingsEditComponent", function() { return ThingSettingsEditComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/_services */ "./src/app/_services/index.ts");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");






let ThingSettingsEditComponent = class ThingSettingsEditComponent {
    constructor(formBuilder, route, missionService, dataStore, httpService, dbService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.missionService = missionService;
        this.dataStore = dataStore;
        this.httpService = httpService;
        this.dbService = dbService;
        this.availableAccessory = new Map();
        this.availableStatus = new Map();
        this.availableControls = new Map();
        this.placeNameSet = new Set();
        this.selectedDeviceLocationString = "Home";
        this.deviceTypeMap = new Map();
        this.accessoryDetailMapString = [];
        this.inputSave = false;
        this.deviceTypeNameArray = [
            "Light",
            "Socket",
            "AC",
            "Fan",
            "Washing Machine",
            "Laptop",
            "Refrigerator",
            "Printer",
            "Wifi",
            "Microwave",
            "TV",
            "Light Array",
            "Geyser",
            "Speaker",
            "Water Purifier",
            "Chandelier",
            "Chimney",
            "Exhaust Fan",
            "Projector"
        ];
        this.roomNameArray = [
            "Study Room",
            "Stairs",
            "Prayer Room",
            "Dressing Room",
            "Guest Bedroom",
            "Bathroom",
            "Entertainment",
            "Living Room",
            "Kids Bedroom",
            "Cellar",
            "Garden",
            "Dinning Room",
            "Master Bedroom",
            "Garage",
            "Hall Way",
            "Kitchen"
        ];
        this.selectedRoomNameString = "";
        this.deviceTypeString = "";
        this.toDetailPage = "";
    }
    ngOnInit() {
        this.loading = true;
        this.inputSave = false;
        this.addNewRoom = false;
        this.listOfplaceName();
        this.selectedMacId = this.route.snapshot.paramMap.get("id");
        this.toDetailPage = this.selectedMacId.split("/")[1];
        this.prepareThingData();
        this.deviceLocation = this.formBuilder.group({
            deviceLocationParam: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        this.roomName = this.formBuilder.group({
            roomNameParam: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        this.deviceTypeName = this.formBuilder.group({
            deviceTypeNameParam: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        this.deviceSwitchName = this.formBuilder.group({
            switchName: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
    }
    prepareThingData() {
        this.dbService.getByKey("Things", this.selectedMacId).then(selectedData => {
            if (selectedData) {
                this.selectedThing = selectedData['thing'];
                this.selectedRoomNameString = this.selectedThing.roomName;
                this.selectedDeviceLocationString = this.selectedThing.thingsLocation.placeName;
                this.selectedThing.accessories.forEach(accessory => {
                    this.availableAccessory.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier, accessory);
                    if (accessory.statusList.length > 0) {
                        accessory.statusList.forEach(status => {
                            this.availableStatus.set(this.selectedThing.macId +
                                "/" +
                                accessory.accessoryIdentifier +
                                "/" +
                                status.statusId, status);
                            this.deviceTypeMap.set(status.accessoryIdentifier, {
                                displayName: accessory.accessoryType,
                                switch: accessory.thingName
                            });
                            this.loading = false;
                        });
                    }
                    if (accessory.thingControl.length > 0) {
                        accessory.thingControl.forEach(control => {
                            this.availableControls.set(this.selectedThing.macId +
                                "/" +
                                accessory.accessoryIdentifier +
                                "/" +
                                control.controlIdentifier, control);
                        });
                    }
                });
            }
        });
    }
    listOfplaceName() {
        this.dbService.getAll("Things").then(Data => {
            Data.forEach(element => {
                if (element['thing'].thingsLocation.placeName) {
                    this.placeNameSet.add(element['thing'].thingsLocation.placeName);
                }
            });
        });
    }
    inputChange(accessoryIdentifier) {
        this.inputSave = true;
        this.accessoryIdentifierinput = accessoryIdentifier;
    }
    deviceNmeAction(accessoryIdentifier) {
        this.inputSave = false;
        if (this.deviceSwitchName.value.switchName !== "") {
            var switchNameChange = {
                key: accessoryIdentifier,
                value: this.deviceSwitchName.value
            };
            for (var [key, value] of this.deviceTypeMap) {
                if (key == switchNameChange.key) {
                    this.deviceTypeMap.set(key, {
                        displayName: value.displayName,
                        switch: switchNameChange.value.switchName
                    });
                }
            }
            this.deviceSwitchName.value.switchName = "";
        }
    }
    getRoomName(roomName) {
        if (roomName === "Add New Room") {
            this.addNewRoom = true;
        }
        this.selectedRoomNameString = roomName;
    }
    getDeviceLocation(deviceLocation) {
        this.selectedDeviceLocationString = deviceLocation;
    }
    getDeviceTypeName(deviceType, currentSwitch, currentIdentifier) {
        this.deviceTypeString = deviceType;
        this.currentSwitch = currentSwitch;
        this.currentIdentifier = currentIdentifier;
        this.deviceTypeMap.set(this.currentIdentifier, {
            displayName: this.deviceTypeString,
            switch: this.currentSwitch
        });
    }
    toThingSettingPage() {
        {
            var toSetting = this.selectedMacId.split("/")[1];
            this.router.navigate(["/dashboard/things"]);
        }
    }
    saveEdittedData() {
        var accessoriesDetails = this.selectedThing.accessories;
        //Below code gives the array of accessories
        accessoriesDetails.forEach(accessory => {
            for (var [key, value] of this.deviceTypeMap) {
                if (accessory.accessoryIdentifier == key) {
                    var accessoryKey = accessory.accessoryIdentifier;
                    this.accessoryDetailMapString.push({
                        [accessoryKey]: {
                            name: value.switch,
                            accessoryType: value.displayName,
                            linkingDetails: {
                                addLinkMacId: "",
                                removeLinkMacId: ""
                            }
                        }
                    });
                }
            }
        });
        var accessoryArrayToObjects = {};
        for (var i = 0; i < this.accessoryDetailMapString.length; i++) {
            accessoryArrayToObjects[i] = this.accessoryDetailMapString[i];
        }
        let accessoryDetailObject = {};
        for (let res in accessoryArrayToObjects) {
            CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
        }
        function CombineObjects(obj, variable) {
            for (let key of Object.keys(obj)) {
                if (!variable[key])
                    variable[key] = {};
                for (let innerKey of Object.keys(obj[key]))
                    variable[key][innerKey] = obj[key][innerKey];
            }
        }
        Object.assign(accessoryDetailObject, { initialModel: this.selectedThing.initialModel }, { initialVersion: this.selectedThing.initialVersion });
        var userAccessObject = [];
        var userAccessArray;
        var status = [];
        var control = [];
        var selectedThingUserAccess = this.selectedThing.userAccess;
        selectedThingUserAccess.forEach(element => {
            var name = element.groupName;
            var userList = element.userList;
            element.statusAccess.forEach(innerStatuselement => {
                status.push(innerStatuselement.statusAccessList);
            });
            element.controlAccess.forEach(innerControlelement => {
                control.push(innerControlelement.controlAccessList);
            });
            (userAccessArray = {
                name: name,
                status: status,
                control: control,
                userList: userList
            }),
                userAccessObject.push(userAccessArray);
        });
        this.updatedThing = {
            admin: this.selectedThing.admins,
            _id: this.selectedThing.serverId,
            type: "thing",
            action: "update",
            macId: this.selectedThing.macId,
            thing: {
                manufacturerDetails: this.selectedThing.manufacturerDetails,
                location: {
                    placeId: "",
                    placeType: this.selectedThing.thingsLocation.placeType,
                    placeName: this.selectedDeviceLocationString,
                    latitude: this.selectedThing.thingsLocation.latitude,
                    longitude: this.selectedThing.thingsLocation.longitude,
                    canEditLocation: this.selectedThing.thingsLocation.canEditLocation
                },
                canChangeThingType: this.selectedThing.canChangeThingType,
                isLinkableThing: this.selectedThing.isLinkableThing,
                model: this.selectedThing.model,
                version: this.selectedThing.version,
                thingType: this.selectedThing.thingType,
                buildNumber: this.selectedThing.buildNumber,
                updatedBy: phoneNumber,
                groupBy: this.selectedThing.groupBy,
                accessoriesDetails: accessoryDetailObject,
                userAccess: userAccessObject,
                roomName: this.selectedRoomNameString
            },
            timeStamp: Date.now(),
            __v: 0
        };
        var payLoad = this.updatedThing;
        let currentUserData = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUserData["phoneNumber"];
        var topic = phoneNumber + "/" + "out";
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => console.log(data));
    }
};
ThingSettingsEditComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_4__["MissionService"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_4__["DataStore"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_4__["HTTPCallsService"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_5__["NgxIndexedDBService"] }
];
ThingSettingsEditComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-thing-settings-edit",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./thing-settings-edit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./thing-settings-edit.component.css */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"],
        src_app_services__WEBPACK_IMPORTED_MODULE_4__["MissionService"],
        src_app_services__WEBPACK_IMPORTED_MODULE_4__["DataStore"],
        src_app_services__WEBPACK_IMPORTED_MODULE_4__["HTTPCallsService"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_5__["NgxIndexedDBService"]])
], ThingSettingsEditComponent);



/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ccDetailActionBar {\n  padding: 2px;\n}\n\n.ccBackIcon {\n  float: left;\n  width: 25px;\n  height: 20px;\n  margin: 15px;\n  cursor: pointer;\n}\n\n.ccEditIcon {\n  float: right;\n  width: 25px;\n  height: 25px;\n  margin: 15px;\n  cursor: pointer;\n}\n\n.ccPowerIcon {\n  float: right;\n  width: 30px;\n  height: 30px;\n  margin: 15px;\n  cursor: pointer;\n}\n\n.ccThingsDetails {\n  color: white;\n  min-height: 100vh;\n  margin-top: 30px;\n}\n\n.ccAccessoryCard {\n  background-color: #353538;\n  margin: 17px;\n  margin-left: 35px;\n  width: 240px;\n  height: 120px;\n\n  border-radius: 17px;\n}\n\n.ccSave{\n  border: 2px #0215fc solid;\n  border-radius: 20px;\n  height: 30px;\n  width: 90px; \n  text-align: center;\n}\n\n.ccProfilePicture {\n  margin-top: 30px;\n  border-radius: 100%;\n  border-color: white;\n  height: 60px;\n  width: 60px;\n  background: #2c2c2b;\n}\n\n.ccThingImage {\n  width: 40%;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  width: 70px;\n  height: 70px;\n}\n\n.ccThingName {\n  /* margin-top: 10px; */\n\n  font-family: Roboto;\n  font-size: 17px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n\n  text-align: left;\n  color: #ffffff;\n  align-self: center;\n}\n\n.ccCategory {\n  font-size: 25px;\n  color: gray;\n  width: 15rem;\n  margin-top: 5px;\n}\n\n.ccItemNames {\n  font-size: 22px;\n  color: white;\n}\n\n.ccControlRow {\n  margin-top: 20px;\n  margin-left: 20px;\n}\n\n.ccThingInfoRow {\n  margin-top: 60px;\n  margin-left: 20px;\n}\n\n.ccControlName {\n  font-size: 17px;\n}\n\n.ccControlButton {\n  width: 5rem;\n}\n\n/* .ccSlider {\n  margin: 20px;\n} */\n\n.ccMemberAccessRow {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  margin-left: 20px;\n}\n\n.ccAdminsCard {\n  margin-top: 10px;\n  margin-right: 20px;\n  margin-left: 75px;\n  /* width: 118%; */\n\n  background-color: #1e1e22;\n}\n\n.ccInnerAdmin {\n  border-radius: 100%;\n  background-color: black;\n  height: 75px;\n  width: 75px;\n  border-color: white;\n}\n\n.ccName {\n  margin-left: 10px;\n}\n\n.ccMemberAccessMargin {\n  margin: 2px;\n}\n\n.ccInnerCardMargin {\n  margin-left: 30px;\n}\n\n.ccLoading {\n  width: 105px;\n  margin-top: 10px;\n}\n\n.ccMemberAccess {\n  margin-top: 5px;\n  font-family: Roboto;\n  font-size: 21px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  text-align: left;\n  color: #ffffff;\n}\n\n.ccMemberAccessIcon {\n  height: 50px;\n  width: 50px;\n  margin-left: 10px;\n}\n\n.ccAddNumber {\n  width: 80px;\n  height: 90 px;\n  background: grey;\n}\n\n.ccAddIcon {\n  margin-top: 5px;\n  margin-left: 10px;\n  height: 30px;\n  width: 30px;\n}\n\n.ccAddUserForm {\n  position: relative;\n  background-color: #272729;\n  margin-right: 60%;\n  margin-left: 10px;\n  border-radius: 10px;\n\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  /* align-items: center; */\n}\n\n.ccAddFormInput {\n  position: relative;\n  margin: inherit;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom-color: black;\n  border-radius: 0%;\n  /* width:; */\n  background: #272729;\n}\n\n.ccAdminTitle {\n  margin-top: 25px;\n  margin-left: 20px;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 0.35;\n  letter-spacing: 0.86px;\n  text-align: left;\n  color: #ffffff;\n}\n\n.ccInnerButtonCard {\n  width: 75px;\n  height: 75px;\n  border-radius: 100%;\n  background-color: #26241f;\n}\n\n.ccFanThingName {\n  margin-top: 10px;\n\n  font-family: Roboto;\n  font-size: 17px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.17;\n  letter-spacing: 0.35px;\n\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n\n.ccSlider {\n  width: 200px;\n}\n\n.ccCurtainButtons {\n  border-radius: 100%;\n  height: 40px;\n  margin: 5px;\n  width: 40px;\n  margin-top: 25px;\n  background: #272729;\n}\n\n.ccCurtainButtonsMargin {\n  margin: 5px;\n}\n\n.ccCurtainCard {\n  /* margin-left: 210px; */\n  margin-top: 3px;\n\n  margin-top: 7px;\n}\n\n.ccCurtainInnerButtonCard {\n  width: 90px;\n  height: 83px;\n  border-radius: 100%;\n  background-color: #26241f;\n}\n\n.ccMargin {\n  margin-left: 20px;\n  margin-top: 20px;\n}\n\n.ccAccessoryCardCurtain {\n  background-color: #353538;\n  margin: 15px;\n  width: 360px;\n  height: 100px;\n  border-radius: 15px;\n\n  align-items: initial;\n  padding-bottom: 110px;\n}\n\n.ccButtonArrayImage {\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n}\n\n.cCBackGroound {\n  background: grey;\n}\n\n.ccbuttonArray {\n  height: 50px;\n  width: 250px;\n  border-radius: 10px;\n  background: gray;\n}\n\n.ccButtonArrayCardLaptop {\n  background: gray;\n  margin: 5px;\n  width: 400px;\n}\n\n.ccThingNameBattery {\n  margin-left: 100px;\n  width: 97px;\n  height: 41px;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.17;\n  letter-spacing: 0.35px;\n  text-align: left;\n  color: #ffffff;\n}\n\n.ccAccessoryCardBattery {\n  height: 85px;\n  background-color: #353538;\n  margin: 15px;\n  width: 260px;\n  border-radius: 15px;\n  padding-bottom: 120px;\n}\n\n.ccBoardDetailsMargin {\n  margin-top: 10px;\n  margin-left: 65px;\n}\n\n.ccSaveButton {\n  width: 80.3px;\n  height: 30.5px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  margin-right: 1px;\n}\n\n.ccCancelButton {\n  width: 80.3px;\n  height: 30.5px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.ccCloseIcon {\n  cursor: pointer;\n  margin-top: 5px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dashboard/things/thing-settings/thing-settings.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/dashboard/things/thing-settings/thing-settings.component.ts ***!
  \*****************************************************************************/
/*! exports provided: ThingSettingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingSettingsComponent", function() { return ThingSettingsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/_services */ "./src/app/_services/index.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var src_app_dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/dashboard/things/msater-control/msater-control.component */ "./src/app/dashboard/things/msater-control/msater-control.component.ts");
/* harmony import */ var _thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./thing-settings-edit/add-number-dialog/add-number-dialog.component */ "./src/app/dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component.ts");










let ThingSettingsComponent = class ThingSettingsComponent {
    constructor(dataStore, route, missionService, dialog, router, httpService, formBuilder, dbService, authService) {
        this.dataStore = dataStore;
        this.route = route;
        this.missionService = missionService;
        this.dialog = dialog;
        this.router = router;
        this.httpService = httpService;
        this.formBuilder = formBuilder;
        this.dbService = dbService;
        this.authService = authService;
        this.availableAccessory = new Map();
        this.availableStatus = new Map();
        this.availableControls = new Map();
        this.availableUsers = new Map();
        this.availableAdmins = new Map();
        this.panelOpenState = false;
        this.accessoryDetailArrayString = [];
        this.usersArray = new Set();
    }
    ngOnInit() {
        this.loading = true;
        this.isUser = false;
        this.selectedMacId = "thing/" + this.route.snapshot.paramMap.get("id");
        this.selectedAccessoryId = this.route.snapshot.paramMap.get("accessoryId");
        this.refreshData();
        this.prepareThingData();
    }
    refreshData() {
        this.prepareThingData();
        this.subscribeToSelectedMacIdData();
    }
    subscribeToSelectedMacIdData() {
        this.timerSubscription = rxjs__WEBPACK_IMPORTED_MODULE_2__["Observable"].timer(1000)
            .first()
            .subscribe(() => this.refreshData());
    }
    prepareThingData() {
        this.dbService.getByKey("Things", this.selectedMacId).then(selectedData => {
            if (selectedData) {
                this.selectedThing = selectedData['thing'];
                if (this.selectedThing.thingType === "laptop") {
                    this.serialNumber = this.selectedThing.macId.split("/")[2].replace(/:/gi, "");
                }
                else {
                    this.serialNumber = this.selectedThing.macId.split("-")[1].replace(/:/gi, "");
                }
                this.currentUser = this.authService.currentUserValue;
                this.selectedThing.userAccess.forEach(element => {
                    element.userList.forEach(elementValue => {
                        this.usersArray.add(elementValue);
                    });
                });
                if (this.usersArray.has(this.currentUser.phoneNumber)) {
                    this.isUser = true;
                }
                else {
                    this.isUser = false;
                }
                this.selectedThing.accessories.forEach(accessory => {
                    var buildNumberObject = {
                        buildNumber: this.selectedThing.buildNumber
                    };
                    var selectedAccessory = Object.assign(accessory, buildNumberObject);
                    this.availableAccessory.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier, selectedAccessory);
                    if (accessory.statusList.length > 0) {
                        accessory.statusList.forEach(status => {
                            this.availableStatus.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier + "/" + status.statusId, status);
                        });
                    }
                    if (accessory.thingControl.length > 0) {
                        accessory.thingControl.forEach(control => {
                            this.availableControls.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier + "/" + control.controlIdentifier, control);
                        });
                    }
                });
                this.selectedThing.admins.forEach(phoneNumber => {
                    this.httpService.getProfileIcon(phoneNumber).subscribe((data) => {
                        this.availableUsers.set(phoneNumber, data);
                    }, (error) => {
                        console.log('Error ', error);
                    });
                });
                this.selectedThing.userAccess.forEach(userAccessElement => {
                    userAccessElement.userList.forEach(userListNumber => {
                        this.httpService.getProfileIcon(userListNumber).subscribe((data) => {
                            this.availableUsers.set(userListNumber, data);
                        }, (error) => {
                            console.log('Error ', error);
                        });
                    });
                });
                this.loading = false;
            }
        });
    }
    getProfilePicture(phoneNumber) {
        return this.availableUsers.get(phoneNumber);
    }
    getMaxValue(states) {
        var max;
        states.forEach(element => {
            for (let [key, value] of element) {
                if (key == "Max") {
                    max = value[0];
                }
            }
        });
        return max;
    }
    getMinValue(states) {
        var min;
        states.forEach(element => {
            for (let [key, value] of element) {
                if (key == "Min") {
                    min = value[0];
                }
            }
        });
        return min;
    }
    getSteps(states) {
        var steps;
        states.forEach(element => {
            for (let [key, value] of element) {
                if (key == "steps") {
                    steps = value[0];
                }
            }
        });
        return steps;
    }
    getCurrentValue(states) {
        var currentValue;
        states.forEach(element => {
            for (let [key, value] of element) {
                if (key == "speed") {
                    currentValue = value;
                }
            }
        });
        return currentValue;
    }
    updateSelectedAccessory(newAccessoryId) {
        this.selectedAccessoryId = newAccessoryId;
        this.prepareThingData();
    }
    controlThing(controlKey, currentState) {
        let control = this.availableControls.get(controlKey);
        var controlChannel = controlKey.split("/");
        var controlTopic = controlChannel[0] +
            "/" +
            controlChannel[1] +
            "/" +
            controlChannel[2] +
            "/" +
            control.topic;
        var message = {};
        this.isSendingStatus = true;
        this.oldStatus = currentState;
        if (currentState == "OFF") {
            message["power"] = { power: ["ON"] };
        }
        else if (currentState == "ON") {
            message["power"] = { power: ["OFF"] };
        }
    }
    editThing(macId) {
        this.router.navigate(["/dashboard/edit/", macId]);
    }
    onInputChange(event, accessory) {
        this.fanSpeedChangeValue = event.value;
        if (this.fanSpeedChangeValue) {
            var payLoad;
            accessory.statusList.forEach(element => {
                if (element.statusId === "speed") {
                    if (accessory.buildNumber < 6) {
                        payLoad = {
                            speed: {
                                currentSpeed: this.fanSpeedChangeValue
                            }
                        };
                    }
                    else if (accessory.buildNumber >= 6) {
                        payLoad = {
                            speed: this.fanSpeedChangeValue
                        };
                    }
                }
            });
            var topic;
            accessory.thingControl.forEach(controlElement => {
                if (controlElement.controlIdentifier == "speed") {
                    topic =
                        accessory.macID +
                            "/" +
                            accessory.accessoryIdentifier +
                            "/" +
                            controlElement.topic;
                }
            });
            let currentUser = JSON.parse(localStorage.getItem("currentUser"));
            var phoneNumber = currentUser["phoneNumber"];
            this.httpService
                .mqttPublish(topic, payLoad, phoneNumber)
                .subscribe(data => console.log(data));
        }
    }
    getCurtainState(state) {
        for (var [key, value] of state) {
            var currentState = key;
        }
        return currentState;
    }
    curtainActionCall(stateValue, accessory) {
        var payLoad;
        for (let [key, value] of stateValue) {
            var currentStatus = key.toLowerCase();
        }
        if (currentStatus === "close") {
            payLoad = {
                close: "CLOSE"
            };
        }
        else if (currentStatus === "open") {
            payLoad = { open: "OPEN" };
        }
        else if (currentStatus === "stop") {
            payLoad = { stop: "STOP" };
        }
        var topic = accessory.macId +
            "/" +
            accessory.accessoryIdentifier +
            "/" +
            accessory.topic;
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUser["phoneNumber"];
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => {
            console.log(data);
            if (data) {
            }
        });
    }
    actionCall(accessory) {
        var payLoad;
        accessory.statusList.forEach(element => {
            if (element.statusId === "power") {
                if (accessory.buildNumber < 6) {
                    var status;
                    var statusCheck = accessory.statusList[0].currentState[0];
                    for (var [key, value] of statusCheck) {
                        status = value;
                    }
                    if (status.toLowerCase() === "on") {
                        payLoad = {
                            power: {
                                power: ["OFF"]
                            }
                        };
                    }
                    else if (status.toLowerCase() === "off") {
                        payLoad = {
                            power: {
                                power: ["ON"]
                            }
                        };
                    }
                }
                else if (accessory.buildNumber >= 6) {
                    var status;
                    var statusCheck = accessory.statusList[0].currentState[0];
                    for (var [key, value] of statusCheck) {
                        status = value;
                    }
                    if (status.toLowerCase() === "on") {
                        payLoad = {
                            power: "OFF"
                        };
                    }
                    else if (status.toLowerCase() === "off") {
                        payLoad = {
                            power: "ON"
                        };
                    }
                }
            }
            else if (element.statusId === "curtain") {
                var statusCheck = accessory.statusList[0].currentState[0];
                for (var [key, value] of statusCheck) {
                    var currentStatus = key.toLowerCase();
                }
                if (currentStatus === "close") {
                    payLoad = {
                        open: "OPEN"
                    };
                }
                else {
                    payLoad = {
                        close: "CLOSE"
                    };
                }
            }
        });
        var topic = accessory.macID +
            "/" +
            accessory.accessoryIdentifier +
            "/" +
            accessory.thingControl[0].topic;
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUser["phoneNumber"];
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => {
            console.log(data);
            if (data) {
            }
        });
    }
    openDialogforUser(groupName) {
        console.log("group Name", groupName);
        const dialogRef = this.dialog.open(_thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_9__["AddNumberDialogComponent"], {
            width: "250px",
            data: { name: this.adminPhoneNumber }
        });
        dialogRef.afterClosed().subscribe(phoneNumber => {
            if (phoneNumber && groupName) {
                this.addUser(phoneNumber, groupName);
            }
        });
    }
    addUser(userphoneNumber, group) {
        var userAccessArray = [];
        var userList = [];
        console.log(this.selectedThing.userAccess);
        this.selectedThing.userAccess.forEach(elementGroup => {
            if (elementGroup.groupName == group) {
                userList = elementGroup.userList;
                userList.push(userphoneNumber);
                var UpdatedGroup = {
                    name: elementGroup.groupName,
                    status: elementGroup.statusAccess,
                    controls: elementGroup.controlAccess,
                    userList: userList
                };
                userAccessArray.push(UpdatedGroup);
            }
            else {
                userAccessArray.push(elementGroup);
            }
        });
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUser["phoneNumber"];
        var accessoriesDetails = this.selectedThing.accessories;
        accessoriesDetails.forEach(accessory => {
            var accessoryKey = accessory.accessoryIdentifier;
            var accessoryValue = {
                name: accessory.thingName,
                subLocation: {
                    roomName: accessory.roomName
                },
                accessoryType: accessory.accessoryType,
                linkingDetails: {
                    addLinkMacId: "",
                    removeLinkMacId: ""
                }
            };
            this.accessoryDetailArrayString.push({
                [accessoryKey]: accessoryValue
            });
        });
        var accessoryArrayToObjects = {};
        for (var i = 0; i < this.accessoryDetailArrayString.length; i++) {
            accessoryArrayToObjects[i] = this.accessoryDetailArrayString[i];
        }
        let accessoryDetailObject = {};
        for (let res in accessoryArrayToObjects) {
            CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
        }
        function CombineObjects(obj, variable) {
            for (let key of Object.keys(obj)) {
                if (!variable[key])
                    variable[key] = {};
                for (let innerKey of Object.keys(obj[key]))
                    variable[key][innerKey] = obj[key][innerKey];
            }
        }
        Object.assign(accessoryDetailObject, { initialModel: this.selectedThing.initialModel }, { initialVersion: this.selectedThing.initialVersion });
        this.updatedThing = {
            admin: this.selectedThing.admins,
            _id: this.selectedThing.serverId,
            type: "thing",
            action: "update",
            macId: this.selectedThing.macId,
            thing: {
                manufacturerDetails: this.selectedThing.manufacturerDetails,
                location: {
                    placeId: "",
                    placeType: this.selectedThing.thingsLocation.placeType,
                    placeName: this.selectedThing.thingsLocation.placeName,
                    latitude: this.selectedThing.thingsLocation.latitude,
                    longitude: this.selectedThing.thingsLocation.longitude,
                    canEditLocation: this.selectedThing.thingsLocation.canEditLocation
                },
                canChangeThingType: this.selectedThing.canChangeThingType,
                isLinkableThing: this.selectedThing.isLinkableThing,
                model: this.selectedThing.model,
                version: this.selectedThing.version,
                thingType: this.selectedThing.thingType,
                buildNumber: this.selectedThing.buildNumber,
                updatedBy: phoneNumber,
                groupBy: this.selectedThing.groupBy,
                accessoriesDetails: accessoryDetailObject,
                userAccess: userAccessArray,
                roomName: this.selectedThing.roomName
            },
            timeStamp: Date.now(),
            __v: 0
        };
        var payLoad = this.updatedThing;
        var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUserData["phoneNumber"];
        var topic = phoneNumber + "/out";
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => console.log(data));
    }
    openDialogforAdmin() {
        const dialogRef = this.dialog.open(_thing_settings_edit_add_number_dialog_add_number_dialog_component__WEBPACK_IMPORTED_MODULE_9__["AddNumberDialogComponent"], {
            width: "250px",
            data: { name: this.adminPhoneNumber }
        });
        dialogRef.afterClosed().subscribe(phoneNumber => {
            console.log(phoneNumber);
            if (phoneNumber != null || undefined) {
                console.log("RESULT", phoneNumber);
                this.addUserAdmin(phoneNumber);
            }
        });
    }
    addUserAdmin(phoneNumber) {
        var newAdminList = this.selectedThing.admins;
        if (phoneNumber) {
            newAdminList.push(phoneNumber);
        }
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        var accessoryDetailsMap = new Map();
        var phoneNumber = currentUser["phoneNumber"];
        var accessoriesDetails = this.selectedThing.accessories;
        accessoriesDetails.forEach(accessory => {
            var accessoryKey = accessory.accessoryIdentifier;
            var accessoryValue = {
                name: accessory.thingName,
                subLocation: {
                    roomName: accessory.roomName
                },
                accessoryType: accessory.accessoryType,
                linkingDetails: {
                    addLinkMacId: "",
                    removeLinkMacId: ""
                }
            };
            this.accessoryDetailArrayString.push({
                [accessoryKey]: accessoryValue
            });
        });
        var accessoryArrayToObjects = {};
        for (var i = 0; i < this.accessoryDetailArrayString.length; i++) {
            accessoryArrayToObjects[i] = this.accessoryDetailArrayString[i];
        }
        let accessoryDetailObject = {};
        for (let res in accessoryArrayToObjects) {
            CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
        }
        function CombineObjects(obj, variable) {
            for (let key of Object.keys(obj)) {
                if (!variable[key])
                    variable[key] = {};
                for (let innerKey of Object.keys(obj[key]))
                    variable[key][innerKey] = obj[key][innerKey];
            }
        }
        Object.assign(accessoryDetailObject, { initialModel: this.selectedThing.initialModel }, { initialVersion: this.selectedThing.initialVersion });
        var userAccessObject = [];
        var userAccessArray;
        var status = [];
        var control = [];
        var selectedThingUserAccess = this.selectedThing.userAccess;
        selectedThingUserAccess.forEach(element => {
            var name = element.groupName;
            var userList = element.userList;
            element.statusAccess.forEach(innerStatuselement => {
                status.push(innerStatuselement.statusAccessList);
            });
            element.controlAccess.forEach(innerControlelement => {
                control.push(innerControlelement.controlAccessList);
            });
            (userAccessArray = {
                name: name,
                status: status,
                control: control,
                userList: userList
            }),
                userAccessObject.push(userAccessArray);
        });
        this.updatedThing = {
            admin: this.selectedThing.admins,
            _id: this.selectedThing.serverId,
            type: "thing",
            action: "update",
            macId: this.selectedThing.macId,
            thing: {
                manufacturerDetails: this.selectedThing.manufacturerDetails,
                location: {
                    placeId: "",
                    placeType: this.selectedThing.thingsLocation.placeType,
                    placeName: this.selectedThing.thingsLocation.placeName,
                    latitude: this.selectedThing.thingsLocation.latitude,
                    longitude: this.selectedThing.thingsLocation.longitude,
                    canEditLocation: this.selectedThing.thingsLocation.canEditLocation
                },
                canChangeThingType: this.selectedThing.canChangeThingType,
                isLinkableThing: this.selectedThing.isLinkableThing,
                model: this.selectedThing.model,
                version: this.selectedThing.version,
                thingType: this.selectedThing.thingType,
                buildNumber: this.selectedThing.buildNumber,
                updatedBy: phoneNumber,
                groupBy: this.selectedThing.groupBy,
                accessoriesDetails: accessoryDetailObject,
                userAccess: userAccessObject,
                roomName: this.selectedThing.roomName
            },
            timeStamp: Date.now(),
            __v: 0
        };
        var payLoad = this.updatedThing;
        var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUserData["phoneNumber"];
        var topic = phoneNumber + "/out";
        console.log("thing", this.updatedThing);
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => console.log(data));
    }
    openDialog() {
        const dialogRef = this.dialog.open(src_app_dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_8__["MsaterControlComponent"], {
            width: "350px",
            data: { name: this.masterStatus }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result != null || undefined) {
                console.log("result", result);
                this.masterStatus = result;
                this.masterOnOff();
            }
        });
    }
    masterOnOff() {
        var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
        var payLoad;
        var phoneNumber = currentUserData["phoneNumber"];
        if (this.selectedThing.buildNumber > 2) {
            var topic = this.selectedMacId + "/masterControl";
            var masterOnOffValueSet = new Set();
            if (this.masterStatus == "OFF") {
                payLoad = { power: "OFF" };
            }
            else {
                payLoad = { power: "ON" };
            }
            this.httpService
                .mqttPublish(topic, payLoad, phoneNumber)
                .subscribe(data => console.log(data));
        }
        else {
            var payLoad;
            console.log(this.masterStatus);
            if (this.masterStatus === 'OFF') {
                payLoad = { power: { power: ["OFF"] } };
            }
            else if (this.masterStatus === 'ON') {
                payLoad = { power: { power: ["ON"] } };
            }
            for (let [key, value] of this.availableStatus) {
                var topic = value.thingMacId + '/' + value.accessoryIdentifier + '/' + 'powerControl';
                this.httpService
                    .mqttPublish(topic, payLoad, phoneNumber)
                    .subscribe(data => {
                    console.log(data);
                });
            }
        }
    }
    ngOnDestroy() {
        this.timerSubscription.unsubscribe();
    }
};
ThingSettingsComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_3__["DataStore"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_3__["MissionService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__["MatDialog"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_3__["HTTPCallsService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__["NgxIndexedDBService"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] }
];
ThingSettingsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-thing-settings",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./thing-settings.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/thing-settings/thing-settings.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./thing-settings.component.css */ "./src/app/dashboard/things/thing-settings/thing-settings.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services__WEBPACK_IMPORTED_MODULE_3__["DataStore"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"],
        src_app_services__WEBPACK_IMPORTED_MODULE_3__["MissionService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__["MatDialog"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"],
        src_app_services__WEBPACK_IMPORTED_MODULE_3__["HTTPCallsService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__["NgxIndexedDBService"],
        src_app_services__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"]])
], ThingSettingsComponent);



/***/ }),

/***/ "./src/app/dashboard/things/things.component.css":
/*!*******************************************************!*\
  !*** ./src/app/dashboard/things/things.component.css ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ccContent {\n  margin: 30px;\n}\n\n.card {\n  border-radius: 10px;\n  background-color: #353538;\n}\n\n.ccInnerCard {\n  background: #26241f;\n  height: 195.3px;\n  width: 195.2px;\n  border-radius: 7px;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  background-color: #26241f;\n  margin-top: 10px;\n  margin-left: 25px;\n  margin-bottom: 10px;\n  border: solid 1px #707070;\n}\n\n.ccMacIdText {\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.17;\n  letter-spacing: 0.38px;\n  text-align: left;\n  color: #ffffff;\n  margin-left: 15px;\n  margin-top: 20px;\n}\n\n.ccAccessoryCard {\n  background-color: #000000;\n  border-radius: 10px;\n  color: white;\n  margin: 20px;\n  text-align: center;\n  width: 13rem;\n  height: 13rem;\n  cursor: pointer;\n}\n\n.ccThingImageContainer {\n  border-radius: 100%;\n  border: solid 1px #707070;\n  height: 120px;\n  width: 120px;\n  background-color: #000000;\n}\n\n.ccThingImage {\n  width: 50%;\n  width: 120px;\n  height: 120px;\n  padding: 20px;\n}\n\n.ccThingName {\n  padding: 7px;\n  font-size: 15px;\n}\n\n.ccThingNameCenter {\n  align-items: center;\n}\n\n.ccStatusDetailText {\n  font-size: 35px;\n}\n\n.ccControlStatus {\n  width: 100px;\n  height: 100px;\n}\n\n.ccLoadingGif {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -50px 0px 0px -50px;\n}\n\n.ccStatusSendGif {\n  width: 50%;\n}\n\n.ccStatusControl {\n  height: 110px;\n}\n\n.ccModal {\n  background-color: #000000d2;\n}\n\n.circular {\n  border-radius: 50%;\n}\n\n.ccLoading {\n  width: 105px;\n  margin-top: 10px;\n}\n\n.ccThings {\n  margin-left: 10px;\n}\n\n.ccPowerIcon {\n  height: 35px;\n  width: 35px;\n  margin-top: 37px;\n  margin-right: 50px;\n  cursor: pointer;\n}\n\n.ccPinIcon {\n  height: 35px;\n  width: 35px;\n  margin-top: 12px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dashboard/things/things.component.ts":
/*!******************************************************!*\
  !*** ./src/app/dashboard/things/things.component.ts ***!
  \******************************************************/
/*! exports provided: ThingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThingsComponent", function() { return ThingsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/_services */ "./src/app/_services/index.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var src_app_dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/dashboard/things/msater-control/msater-control.component */ "./src/app/dashboard/things/msater-control/msater-control.component.ts");








let ThingsComponent = class ThingsComponent {
    constructor(missionService, dataStore, router, route, thingSyncService, authService, httpService, dbService, dialog) {
        this.missionService = missionService;
        this.dataStore = dataStore;
        this.router = router;
        this.route = route;
        this.thingSyncService = thingSyncService;
        this.authService = authService;
        this.httpService = httpService;
        this.dbService = dbService;
        this.dialog = dialog;
        this.selectedThingId = "";
        this.selectedThingMacId = "";
        this.displayModel = "none";
        this.name = new Set();
        this.existingRppmName = ['bathroom', 'bed room', 'bedroom', 'cellar', 'dinning room', 'dressing', 'entertainment', 'entrance', 'garage', 'garden', 'guesr bedroom', 'hall way', 'home', 'kids bedroom', 'kitchen', 'living room', 'master bedroom', 'office', 'prayer room', 'stairs', 'study room'];
        this.existingPlaceType = ['Restaurent', 'Office'];
        this.thingUIObject = new Map();
        this.globalThingAndThingUIObject = new Map();
    }
    ngOnInit() {
        this.loading = true;
        this.currentUser = this.authService.currentUserValue;
        this.selectedPlaceName = this.route.snapshot.paramMap.get("label");
        this.thingAndThingUIObjectCall();
        this.missionService.missionAnnounced$.subscribe(mission => {
            switch (mission.split("!#!")[0]) {
                case "DataSaved":
                    this.getData();
                    break;
                case "ThingsUpdated":
                    this.thingAndThingUIObjectCall();
                    break;
                case "sort":
                    this.selectedPlaceName = mission.split("!#!")[1];
                    this.thingAndThingUIObjectCall();
                    break;
                case "removeSort":
                    this.selectedPlaceName = "";
                    this.thingAndThingUIObjectCall();
                    break;
            }
        });
    }
    getData() {
        this.dataStore.getAllThingData();
    }
    thingAndThingUIObjectCall() {
        this.name.clear();
        let ThingAndThingUIObject = new Map();
        this.dbService.getAll('Things').then(allData => {
            // console.log(allData)
            var thingDataMap = allData;
            this.dbService.getAll('thingUiObject').then(allUidata => {
                // console.log(allUidata)
                thingDataMap.forEach(value => {
                    if (value['thing'].macId.includes("-")) {
                        var macIdcheck = value['thing'].macId.toLowerCase().split("-")[1];
                    }
                    else {
                        var macIdcheck = value['thing'].macId.toLowerCase().split("/")[2];
                    }
                    if (this.selectedPlaceName) {
                        if (this.selectedPlaceName.toLowerCase() === "others" ||
                            "others".match(this.selectedPlaceName)) {
                            var thingCardName = "-";
                            var MatchedStatus = new Map();
                            allUidata.forEach(data => {
                                if (thingCardName == data['thing'].eachthingName || data['thing'].eachthingName == "Others") {
                                    MatchedStatus.set(data['uiMacId'], data['thing']);
                                }
                            });
                            if (value['Thing']) {
                                if (((value['Thing'].thingsLocation.placeName === null ||
                                    value['Thing'].thingsLocation.placeName === "") &&
                                    value['Thing'].roomName === null) ||
                                    value['Thing'].roomName === "") {
                                    ThingAndThingUIObject.set("Others", MatchedStatus);
                                }
                            }
                            {
                                ThingAndThingUIObject.set("Others", MatchedStatus);
                            }
                        }
                        else if (value['thing'].thingsLocation.placeName
                            .toLowerCase()
                            .match(this.selectedPlaceName) ||
                            this.selectedPlaceName.toLowerCase() ===
                                value['thing'].thingsLocation.placeName.toLowerCase() ||
                            macIdcheck.match(this.selectedPlaceName)) {
                            if (value['thing'].roomName != '') {
                                this.cardName =
                                    value['thing'].thingsLocation.placeName + "-" + value['thing'].roomName + "*";
                                if (this.existingRppmName.includes(value['thing'].roomName)) {
                                    this.cardName =
                                        this.cardName + 'icon' + value['thing'].roomName;
                                }
                                else if (this.existingPlaceType.includes(value['thing'].thingsLocation.placeType)) {
                                    this.cardName =
                                        this.cardName + 'icon' + value['thing'].thingsLocation.placeType;
                                }
                                else {
                                    this.cardName =
                                        this.cardName + 'icon' + 'pin';
                                }
                            }
                            else if (value['thing'].thingsLocation.placeName) {
                                this.cardName = value['thing'].thingsLocation.placeName + '-*iconpin';
                            }
                            else {
                                this.cardName =
                                    '-*iconpin';
                            }
                            var MatchedStatus = new Map();
                            allUidata.forEach(data => {
                                if (this.cardName.split('*')[0].replace('*', '') == data['thing'].eachthingName) {
                                    MatchedStatus.set(data['uiMacId'], data['thing']);
                                }
                            });
                            if (MatchedStatus.size > 0) {
                                ThingAndThingUIObject.set(this.cardName, MatchedStatus);
                            }
                        }
                    }
                    else {
                        this.cardName = '';
                        if (value['thing'].roomName != '') {
                            this.cardName =
                                value['thing'].thingsLocation.placeName + "-" + value['thing'].roomName + "*";
                            if (this.existingRppmName.includes(value['thing'].roomName)) {
                                this.cardName =
                                    this.cardName + 'icon' + value['thing'].roomName;
                            }
                            else if (this.existingPlaceType.includes(value['thing'].thingsLocation.placeType)) {
                                this.cardName =
                                    this.cardName + 'icon' + value['thing'].thingsLocation.placeType;
                            }
                            else {
                                this.cardName =
                                    this.cardName + 'icon' + 'pin';
                            }
                        }
                        else if (value['thing'].thingsLocation.placeName) {
                            this.cardName = value['thing'].thingsLocation.placeName + '-*iconpin';
                        }
                        else {
                            this.cardName =
                                '-*iconpin';
                        }
                        var MatchedStatus = new Map();
                        allUidata.forEach(data => {
                            if (data['uiMacId'].includes("thing/esp-EC:FA:BC:62:50:7D")) {
                            }
                            if (this.cardName.split('*')[0].replace('*', '') == (data['thing'].eachthingName)) {
                                MatchedStatus.set(data['uiMacId'], data['thing']);
                            }
                        });
                        if (MatchedStatus.size > 0) {
                            if (this.cardName === '-*iconpin') {
                                ThingAndThingUIObject.set("Others", MatchedStatus);
                                this.dbService.update('locationList', { name: 'Others', id: "Others" }).then(() => {
                                });
                            }
                            else {
                                ThingAndThingUIObject.set(this.cardName, MatchedStatus);
                                this.dbService.update('locationList', { name: this.cardName.split('-')[0], id: this.cardName.split('-')[0] }).then(() => {
                                });
                            }
                        }
                    }
                    this.loading = false;
                });
                this.globalThingAndThingUIObject = ThingAndThingUIObject;
                this.missionService.announceMission('LocationListFramed');
            });
        });
    }
    thingControl(key, macId) {
        if (macId.includes("laptop")) {
            this.router.navigate([
                "/dashboard/thingDetails/",
                macId.split("/")[1] + "/" + macId.split("/")[2],
                key.split("/")[3]
            ]);
        }
        else {
            this.router.navigate([
                "/dashboard/thingDetails/",
                macId.split("/")[1],
                key.split("/")[2]
            ]);
        }
    }
    actionCall(accessory) {
        var payLoad;
        var currentStatuskey = accessory.currentStatus.toLowerCase();
        var currentStatusValue = accessory.currentStatus.toUpperCase();
        if (accessory.accessoryId.includes("curtain")) {
            var currentStatus = accessory.currentStatus.toLowerCase();
            if (currentStatus === "close") {
                payLoad = {
                    open: "OPEN"
                };
            }
            else {
                payLoad = {
                    close: "CLOSE"
                };
            }
        }
        else {
            if (accessory.buildNumber < 6 || accessory.buildNumber == undefined) {
                var status = accessory.currentStatus;
                if (status.toLowerCase() === "on") {
                    payLoad = {
                        power: {
                            power: ["OFF"]
                        }
                    };
                }
                else if (status.toLowerCase() === "off") {
                    payLoad = {
                        power: {
                            power: ["ON"]
                        }
                    };
                }
            }
            else if (accessory.buildNumber >= 6) {
                var status = accessory.currentStatus;
                if (status.toLowerCase() === "on") {
                    payLoad = {
                        power: "OFF"
                    };
                }
                else if (status.toLowerCase() === "off") {
                    payLoad = {
                        power: "ON"
                    };
                }
            }
        }
        var topic = accessory.accessoryId + "/" + accessory.controlTopic;
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUser["phoneNumber"];
        this.httpService
            .mqttPublish(topic, payLoad, phoneNumber)
            .subscribe(data => console.log(data));
    }
    openDialog(eachthing) {
        const dialogRef = this.dialog.open(src_app_dashboard_things_msater_control_msater_control_component__WEBPACK_IMPORTED_MODULE_6__["MsaterControlComponent"], {
            width: "350px",
            data: { name: this.masterStatus }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result != null || undefined) {
                this.masterOnOffThings(result, eachthing);
            }
        });
    }
    masterOnOffThings(masterStatus, eachThing) {
        var masterOnOffThingsMapNew = new Map();
        var masterOnOffThingsMapOld = new Map();
        var masterOnOffThingsSetNew = new Set();
        var masterOnOffThingsSetOld = new Set();
        var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
        var phoneNumber = currentUserData["phoneNumber"];
        var payLoad, topic;
        for (let [key, value] of eachThing.value) {
            if (value.buildNumber > 2) {
                masterOnOffThingsMapNew.set(value.macId, masterStatus);
            }
            else {
                masterOnOffThingsMapOld.set(value.accessoryId, masterStatus);
            }
        }
        // console.log(masterOnOffThingsMapOld);
        // console.log(masterOnOffThingsMapNew);
        if (masterOnOffThingsSetNew) {
            for (let [key, value] of masterOnOffThingsMapNew) {
                var checkStatus = JSON.stringify(value);
                if (checkStatus === '"OFF"') {
                    payLoad = { power: "OFF" };
                }
                else if (checkStatus === '"ON"') {
                    payLoad = { power: "ON" };
                }
                topic = key + "/masterControl";
                this.httpService
                    .mqttPublish(topic, payLoad, phoneNumber)
                    .subscribe(data => {
                    console.log(data);
                });
            }
        }
        if (masterOnOffThingsSetOld) {
            for (let [key, value] of masterOnOffThingsMapOld) {
                var checkStatus = JSON.stringify(value);
                if (checkStatus === '"OFF"') {
                    payLoad = { power: { power: ["OFF"] } };
                }
                else if (checkStatus === '"ON"') {
                    payLoad = { power: { power: ["ON"] } };
                }
                topic = key + "/powerControl";
                console.log("topic", topic);
                this.httpService
                    .mqttPublish(topic, payLoad, phoneNumber)
                    .subscribe(data => {
                    console.log(data);
                });
            }
        }
    }
};
ThingsComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["MissionService"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["DataStore"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["ThingsSyncService"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"] },
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["HTTPCallsService"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_4__["NgxIndexedDBService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"] }
];
ThingsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-things",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./things.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dashboard/things/things.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./things.component.css */ "./src/app/dashboard/things/things.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services__WEBPACK_IMPORTED_MODULE_2__["MissionService"],
        src_app_services__WEBPACK_IMPORTED_MODULE_2__["DataStore"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"],
        src_app_services__WEBPACK_IMPORTED_MODULE_2__["ThingsSyncService"],
        src_app_services__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"],
        src_app_services__WEBPACK_IMPORTED_MODULE_2__["HTTPCallsService"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_4__["NgxIndexedDBService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"]])
], ThingsComponent);



/***/ }),

/***/ "./src/app/login/index.ts":
/*!********************************!*\
  !*** ./src/app/login/index.ts ***!
  \********************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _login_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./login.component */ "./src/app/login/login.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return _login_component__WEBPACK_IMPORTED_MODULE_1__["LoginComponent"]; });





/***/ }),

/***/ "./src/app/login/login.component.css":
/*!*******************************************!*\
  !*** ./src/app/login/login.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ccLoading {\n    width: 105px;\n  }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbG9naW4vbG9naW4uY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFlBQVk7RUFDZCIsImZpbGUiOiJzcmMvYXBwL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY2NMb2FkaW5nIHtcbiAgICB3aWR0aDogMTA1cHg7XG4gIH0iXX0= */");

/***/ }),

/***/ "./src/app/login/login.component.ts":
/*!******************************************!*\
  !*** ./src/app/login/login.component.ts ***!
  \******************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");
/* harmony import */ var ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-indexed-db */ "./node_modules/ngx-indexed-db/fesm2015/ngx-indexed-db.js");








let LoginComponent = class LoginComponent {
    constructor(dataStore, formBuilder, route, router, authenticationService, alertService, dbService) {
        this.dataStore = dataStore;
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.alertService = alertService;
        this.dbService = dbService;
        this.loading = false;
        this.submitted = false;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(["/"]);
        }
    }
    getNumber(event) {
        this.ccode = 91;
    }
    onCountryChange(event) {
        this.ccode = event.dialCode;
    }
    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            password: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            provider: ["Approver"],
            AppVersion: 10
        });
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
        // show success message on registration
        if (this.route.snapshot.queryParams["registered"]) {
            this.success = "Registration successful";
        }
    }
    // convenience getter for easy access to form fields
    get formValidation() {
        return this.loginForm.controls;
    }
    onSubmit() {
        this.submitted = true;
        // reset alerts on submit
        this.error = null;
        this.success = null;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.dbService.clear('Things').then(() => {
            // console.log("THINGS")
            this.dbService.clear('thingUiObject').then(() => {
                // console.log("THING UI OBJECT")
                this.dbService.clear('locationList').then(() => {
                    this.authenticationService
                        .login(this.ccode + this.formValidation.username.value, this.formValidation.password.value, this.formValidation.provider, this.formValidation.AppVersion)
                        .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
                        .subscribe(data => {
                        this.loading = false;
                        this.router.navigate(["/dashboard/things"]);
                    }, error => {
                        if (error.statusText == "Unknown Error") {
                            this.alertService.error("Please check your connectivity");
                        }
                        else if (error.status == 400) {
                            this.alertService.error("Please check the entered credentials");
                        }
                        this.loading = false;
                    });
                }, error => {
                    console.log(error);
                });
            }, error => {
                console.log(error);
            });
        }, error => {
            console.log(error);
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["DataStore"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AlertService"] },
    { type: ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__["NgxIndexedDBService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({ template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html")).default, selector: "login", styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/login/login.component.css")).default] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services__WEBPACK_IMPORTED_MODULE_5__["DataStore"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"],
        _services__WEBPACK_IMPORTED_MODULE_5__["AlertService"],
        ngx_indexed_db__WEBPACK_IMPORTED_MODULE_6__["NgxIndexedDBService"]])
], LoginComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/vignesh/WorkDirectory/Angular/angular/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map